window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));

  // Global sections event listeners
  // Section select
  $(document).on('shopify:section:select', function(evt) {
    if (evt.detail.sectionId !== 'sidebar-menu') {
      theme.LeftDrawer.close();
    }
  });
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) return;

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


/* ================ MODULES ================ */
window.a11y = window.a11y || {};

a11y.trapFocus = function($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1').focus();

  $(document).on(eventName, function(evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();
    }
  });
};

a11y.removeTrapFocus = function($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.removeAttr('tabindex');
  $(document).off(eventName);
};

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('body, html')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.$focusOnOpen
      ? $(this.config.$focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    a11y.trapFocus(this.$focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    a11y.removeTrapFocus(this.$focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

/**
 *  Vendor
 *
 *  Small minified vendor scripts can be placed at the top of this file to
 *  reduce network requests.
 *
 */

/**
 *
 *  ShopifyCanvas JS
 *  - Base Canvas functions and utilities.
 *
 */

window.ShopifyCanvas = window.ShopifyCanvas || {};

/**
 *
 *  Initialize function for all ShopifyCanvas JS.
 *  - call any functions required on page load here.
 *
 */
ShopifyCanvas.init = function() {
  ShopifyCanvas.cacheSelectors();
  ShopifyCanvas.checkUrlHash();
  ShopifyCanvas.initEventListeners();
  ShopifyCanvas.resetPasswordSuccess();
  ShopifyCanvas.customerAddressForm();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
ShopifyCanvas.cacheSelectors = function() {
  ShopifyCanvas.cache = {
    $html: $('html'),
    $body: $('body')
  };
};

ShopifyCanvas.initEventListeners = function() {
  //Show reset password form
  $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });

  //Hide reset password form
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });
};

/**
 *
 *  Show/Hide recover password form
 *
 */
ShopifyCanvas.toggleRecoverPasswordForm = function() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
};

/**
 *
 *  Show reset password success message
 *
 */
ShopifyCanvas.resetPasswordSuccess = function() {
  var $formState = $('.reset-password-success');

  //check if reset password form was successfully submited.
  if (!$formState.length) return;

  // show success message
  $('#ResetSuccess').removeClass('hide');
};

/**
 *
 *  Show/hide customer address forms
 *
 */
ShopifyCanvas.customerAddressForm = function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) return;

  // Initialize observers on address selectors, defined in shopify_common.js
  new Shopify.CountryProvinceSelector(
    'AddressCountryNew',
    'AddressProvinceNew',
    {
      hideElement: 'AddressProvinceContainerNew'
    }
  );

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      });
    }
  });
};

/**
 *
 *  Check URL for reset password hash
 *
 */
ShopifyCanvas.checkUrlHash = function() {
  var hash = ShopifyCanvas.getHash();

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    ShopifyCanvas.toggleRecoverPasswordForm();
  }
};

/**
 *
 *  Get the hash from the URL
 *
 */
ShopifyCanvas.getHash = function() {
  return window.location.hash;
};

// Initialize ShopifyCanvas's JS on docready
$(ShopifyCanvas.init);

/*
 * Returns a function which adds a vendor prefix to any CSS property name
 * Source https://github.com/markdalgleish/stellar.js/blob/master/src/jquery.stellar.js
 */

var vendorPrefix = (function() {
  var prefixes = /^(Moz|Webkit|O|ms)(?=[A-Z])/,
    style = $('script')[0].style,
    prefix = '',
    prop;

  for (prop in style) {
    if (prefixes.test(prop)) {
      prefix = prop.match(prefixes)[0];
      break;
    }
  }

  if ('WebkitOpacity' in style) {
    prefix = 'Webkit';
  }
  if ('KhtmlOpacity' in style) {
    prefix = 'Khtml';
  }

  return function(property) {
    return (
      prefix +
      (prefix.length > 0
        ? property.charAt(0).toUpperCase() + property.slice(1)
        : property)
    );
  };
})();

/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in src/javascripts/slick.min.js (dev)
 *   Added to the top of this file in production

 * Requires $.debounce function from theme.js
 */

var slickTheme = (function(module, $) {
  'use strict';

  // Public functions
  var init, onInit, beforeChange, afterChange;

  // Private variables
  var settings,
    $slider,
    $allSlides,
    $activeSlide,
    $slickDots,
    $paginations,
    $mobileDotsContainer,
    windowHeight,
    scrolled,
    prefixedTransform;
  var currentActiveSlide = 0;

  // Private functions
  var cacheObjects,
    setFullScreen,
    setPaginationAttributes,
    adaptHeight,
    showActiveContent,
    keyboardNavigation,
    togglePause,
    sizeFullScreen,
    setParallax,
    calculateParallax,
    slideshowA11ySetup;

  /*============================================================================
  Initialise the plugin and define global options
  ==============================================================================*/
  cacheObjects = function() {
    slickTheme.cache = {
      $html: $('html'),
      $window: $(window),
      $hero: $('#Hero'),
      $heroImage: $('.hero__image'),
      $pauseButton: $('.hero__pause'),
      $heroDotsWrapper: $('.hero__dots-wrapper'),
      $heroDotsWrapperDesktop: $('.hero__dots-wrapper-desktop'),
      $heroContentWrapperMobile: $('.hero__content-wrapper-mobile'),
      $heroHeader: $('.hero__header')
    };

    slickTheme.vars = {
      slideClass: 'slick-slide',
      activeClass: 'slick-active',
      slickList: '.slick-list',
      slickDots: '.slick-dots',
      slickActiveMobile: 'slick-active-mobile',
      hiddenClass: 'hero__slide--hidden',
      pausedClass: 'is-paused',
      activeContentClass: 'is-active',
      pagination: '[data-slide-pagination]',
      adapt: slickTheme.cache.$hero.data('adapt'),
      loadSlideA11yString: slickTheme.cache.$hero.data('slide-nav-a11y'),
      activeSlideA11yString: slickTheme.cache.$hero.data(
        'slide-nav-active-a11y'
      )
    };
  };

  init = function(options) {
    cacheObjects();

    // Default settings
    settings = {
      // User options
      $element: null,

      // Private settings
      isTouch: slickTheme.cache.$html.hasClass('supports-touch') ? true : false,

      // Slick options
      arrows: false,
      dots: true,
      adaptiveHeight: false
    };

    // Override defaults with arguments
    $.extend(settings, options);

    /*
    * Init slick slider
    *   - Add any additional option changes here
    *   - https://github.com/kenwheeler/slick/#options
    */
    settings.$element.slick({
      arrows: settings.arrows,
      dots: settings.dots,
      draggable: false,
      fade: true,
      slide: '.hero__slide',
      /*eslint-disable shopify/jquery-dollar-sign-reference */
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      appendDots: $('.hero__dots-wrapper'),
      /*eslint-enable shopify/jquery-dollar-sign-reference */
      autoplay: slickTheme.cache.$hero.data('autoplay'),
      autoplaySpeed: slickTheme.cache.$hero.data('autoplayspeed'),
      speed: settings.speed,
      pauseOnHover: false,
      onInit: this.onInit,
      onBeforeChange: this.beforeChange,
      onAfterChange: this.afterChange,
      customPaging: function(slick, index) {
        var labelString =
          index === 0
            ? slickTheme.vars.activeSlideA11yString
            : slickTheme.vars.loadSlideA11yString;
        return (
          '<a href="#Hero" class="hero__dots" aria-label="' +
          labelString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '" data-slide-pagination aria-controls="SlickSlide' +
          (index + 1) +
          '"></a>'
        );
      }
    });
  };

  onInit = function(obj) {
    $slider = obj.$slider;
    $allSlides = $slider.find('.' + slickTheme.vars.slideClass);
    $activeSlide = $slider.find('.' + slickTheme.vars.activeClass);
    $slickDots = $(slickTheme.vars.slickDots);
    $paginations = slickTheme.cache.$heroDotsWrapper.find(
      slickTheme.vars.pagination
    );
    $mobileDotsContainer = slickTheme.cache.$heroContentWrapperMobile.find(
      slickTheme.vars.slickDots
    );

    if (!settings.isTouch) {
      $allSlides.addClass(slickTheme.vars.hiddenClass);
      $activeSlide.removeClass(slickTheme.vars.hiddenClass);
    }

    if (slickTheme.vars.adapt) {
      adaptHeight();
      showActiveContent(0);
    } else {
      setFullScreen();
    }

    if (slickTheme.cache.$html.hasClass('supports-csstransforms3d')) {
      setParallax();
    }

    //trigger event that slick has initialized
    slickTheme.cache.$window.trigger('slick-initialized');

    if (settings.autoplay) {
      slickTheme.cache.$pauseButton.on('click', togglePause);
    }

    slideshowA11ySetup();
  };

  beforeChange = function(evt, currentSlide, nextSlide) {
    if (!settings.isTouch) {
      $allSlides.removeClass(slickTheme.vars.hiddenClass);
    }

    // Set upcoming slide as index
    currentActiveSlide = nextSlide;

    // Set new active slide to proper parallax position
    if (slickTheme.cache.$html.hasClass('supports-csstransforms3d')) {
      calculateParallax(currentActiveSlide);
    }

    var $desktopPagination = slickTheme.cache.$heroDotsWrapperDesktop.find(
      slickTheme.vars.pagination
    );

    var $mobilePagination = slickTheme.cache.$heroContentWrapperMobile.find(
      slickTheme.vars.pagination
    );

    // initialize both $desktopPagination and $mobilePagination
    // at the same time
    $desktopPagination.each(function(index) {
      var currentElem = this;
      setPaginationAttributes(currentElem, index, nextSlide);
    });

    $mobilePagination.each(function(index) {
      var currentElem = this;
      setPaginationAttributes(currentElem, index, nextSlide);
    });

    $paginations
      .removeAttr('aria-current', 'true')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    if (!slickTheme.vars.adapt || !$mobileDotsContainer.length) {
      return;
    }

    var $mobileDotsList = $mobileDotsContainer.find('li');

    showActiveContent(nextSlide);

    // toggle active class on mobile dots
    $mobileDotsList
      .removeAttr('aria-hidden')
      .removeClass(slickTheme.vars.slickActiveMobile)
      .eq(nextSlide)
      .addClass(slickTheme.vars.slickActiveMobile)
      .attr('aria-hidden', false);
  };

  afterChange = function() {
    var $dotsList = $slickDots.find('li');
    var $activeDot = $slickDots.find('.' + slickTheme.vars.activeClass);

    $dotsList.removeAttr('aria-hidden');
    $activeDot.attr('aria-hidden', false);

    if (settings.isTouch) return;

    $activeSlide = $slider.find('.' + slickTheme.vars.activeClass);
    $allSlides.addClass(slickTheme.vars.hiddenClass).attr('aria-hidden', true);
    $activeSlide
      .removeClass(slickTheme.vars.hiddenClass)
      .attr('aria-hidden', false);
  };

  setPaginationAttributes = function(currentElem, index, nextSlide) {
    var labelString =
      index === nextSlide
        ? slickTheme.vars.activeSlideA11yString
        : slickTheme.vars.loadSlideA11yString;

    labelString = labelString.replace('[slide_number]', index + 1);
    $(currentElem).attr('aria-label', labelString);
  };

  adaptHeight = function() {
    // Set class on action bar
    slickTheme.cache.$heroHeader.addClass('hero__header--adapt');

    // set custom dot class for adapt height on mobile
    if (!$mobileDotsContainer.length) {
      return;
    }

    var $initialActiveDot = $mobileDotsContainer.find('li:first-of-type');
    $initialActiveDot.addClass(slickTheme.vars.slickActiveMobile);
  };

  setFullScreen = function() {
    sizeFullScreen();

    // Resize hero after screen resize
    slickTheme.cache.$window.on('resize', $.debounce(250, sizeFullScreen));
  };

  showActiveContent = function(slideIndex) {
    if ($allSlides.length <= 1) return;

    var $contentMobile = $('.hero__content-mobile');

    if (!$contentMobile.length) {
      return;
    }

    var $currentContentMobile = $contentMobile.filter(
      '[data-index="' + (slideIndex + 1) + '"]'
    );

    $contentMobile.removeClass(slickTheme.vars.activeContentClass);
    $currentContentMobile.addClass(slickTheme.vars.activeContentClass);
  };

  keyboardNavigation = function(evt) {
    if (evt.keyCode === 37) {
      settings.$element.slickPrev();
    }
    if (evt.keyCode === 39) {
      settings.$element.slickNext();
    }
  };

  togglePause = function() {
    var $pauseButton = $(this);
    var isPaused = $pauseButton.hasClass(slickTheme.vars.pausedClass);

    $pauseButton
      .toggleClass(slickTheme.vars.pausedClass, !isPaused)
      .attr(
        'aria-label',
        isPaused
          ? $pauseButton.data('label-pause')
          : $pauseButton.data('label-play')
      );

    if (settings.autoplay) {
      if (isPaused) {
        settings.$element.slickPlay();
      } else {
        settings.$element.slickPause();
      }
    }
  };

  sizeFullScreen = function() {
    if (theme.cache.$announcementBar.length) {
      windowHeight =
        slickTheme.cache.$window.height() -
        theme.cache.$announcementBar.height();
    } else {
      windowHeight = slickTheme.cache.$window.height();
    }

    settings.$element.css('height', windowHeight);
  };

  setParallax = function() {
    prefixedTransform = vendorPrefix ? vendorPrefix('transform') : 'transform';

    slickTheme.cache.$window.on('scroll', function() {
      calculateParallax(currentActiveSlide);
    });
  };

  calculateParallax = function(currentSlide) {
    scrolled = slickTheme.cache.$window.scrollTop();

    if (slickTheme.cache.$heroImage[currentSlide]) {
      slickTheme.cache.$heroImage[currentSlide].style[prefixedTransform] =
        'translate3d(0, ' + scrolled / 4.5 + 'px, 0)';
    }

    if (theme.cache.$announcementBar.length) {
      $(theme.cache.$announcementBar).css({
        transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
      });
    }
  };

  slideshowA11ySetup = function() {
    var $list = slickTheme.cache.$hero.find(slickTheme.vars.slickList);
    var $dotsList = $slickDots.find('li');
    var $activeDot = $slickDots.find('.' + slickTheme.vars.activeClass);
    var $mobileActiveDot = $slickDots.find(
      '.' + slickTheme.vars.slickActiveMobile
    );
    // When an element in the slider is focused
    // pause slideshow and set active slide aria-live.
    slickTheme.cache.$hero
      .on('focusin', function(evt) {
        if (
          !slickTheme.cache.$hero.has(evt.target).length ||
          $list.attr('aria-live') === 'polite'
        ) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (settings.autoplay) {
          settings.$element.slickPause();
        }
      })
      .on('focusout', function(evt) {
        if (slickTheme.cache.$hero.has(evt.relatedTarget).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (settings.autoplay) {
          // Only resume playing if the user hasn't paused using the pause
          // button
          if (
            !slickTheme.cache.$pauseButton.hasClass(slickTheme.vars.pausedClass)
          ) {
            settings.$element.slickPlay();
          }
        }
      })
      .on('keyup', keyboardNavigation.bind(this));

    $list.removeAttr('tabindex');
    $dotsList.removeAttr('aria-hidden');
    $activeDot.attr('aria-hidden', false);
    $mobileActiveDot.attr('aria-hidden', false);

    if ($allSlides.length > 1) {
      $paginations
        .each(function() {
          $(this).on('click keyup', function(evt) {
            if (evt.type === 'keyup' && evt.which !== 13) return;

            evt.preventDefault();

            slickTheme.cache.$hero.attr('tabindex', -1);

            if (evt.type === 'keyup') {
              slickTheme.cache.$hero.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }
  };

  module = {
    init: init,
    onInit: onInit,
    beforeChange: beforeChange,
    afterChange: afterChange
  };

  return module;
})(slickTheme || {}, jQuery);

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

theme.ActionBar = (function() {
  function init() {
    cacheSelectors();
    initStickyActionBar();
    initActionBar();

    theme.cache.$window.on('resize', $.debounce(250, resizeEvents));
  }

  function cacheSelectors() {
    var cache = {
      $actionBar: $('.action-bar'),
      $actionArea: $('.action-area'),
      $actionBarWrapper: $('.action-bar-wrapper'),
      $actionBarMenus: $('.action-bar__menu'),
      $actionBarMenuHasDropdown: $('.action-bar--has-dropdown'),
      $activeActionBarHasSubMenu: $(
        '.action-bar--has-dropdown.action-bar--active'
      ),
      $actionBarMainMenu: $('.action-bar__menu--main'),
      $actionBarSubMenus: $('.action-bar__menu--sub'),
      $actionBarBack: $('.action-bar__back'),
      $actionBarMainMenuFirst: $(
        '.action-bar__menu--main .action-bar__link'
      ).eq(0)
    };

    $.extend(theme.cache, cache);

    var variables = {
      previousScrollPosition: 0,
      hasActionBar: theme.cache.$actionBar.length,
      actionBarOffsetTop: 0,
      actionBarOffsetBottom: 0,
      stickyClass: 'js-sticky-action-bar',
      actionBarOpenTransitionClass: 'js-sticky-action-bar--open'
    };

    $.extend(theme.variables, variables);
  }

  function initActionBar() {
    actionBarScroll();

    if (theme.cache.$actionBarMenuHasDropdown.length) {
      actionBarDropdowns();
    }

    theme.cache.$window.on('resize', $.debounce(500, actionBarScroll));
  }

  function actionBarDropdowns() {
    var $activeSubNavItem = theme.cache.$actionBarSubMenus.find(
      '.action-bar--active'
    );
    var activeSubNavTarget = theme.cache.$activeActionBarHasSubMenu.attr(
      'data-child-list-handle'
    );
    var showClass = 'action-bar--show';

    theme.cache.$actionBarBack.on('click', closeSubNav);

    // Prevent Click Event on action bar links which have submenus if they
    // are active
    theme.cache.$actionBarMainMenu.on(
      'click',
      '.action-bar--disabled',
      function(evt) {
        evt.preventDefault();

        openSubNavFromNavItem();
      }
    );

    if ($activeSubNavItem.length) {
      openSubNavFromSubNavItem();
    }

    /*
      Open SubNav if there is an active Parent with a dropdown in the action bar
     */
    function openSubNavFromNavItem() {
      theme.cache.$actionBarMainMenu.removeClass(showClass);

      // loop through any dropdowns that exist
      theme.cache.$actionBarSubMenus.each(function() {
        var $el = $(this);

        if (activeSubNavTarget === $el.attr('data-child-list-handle')) {
          $el.prepareTransition().addClass(showClass);
          theme.setFocus($el.find('.action-bar__link').eq(0), 'action-bar');
        }
      });

      actionBarScroll();
    }

    /*
      Open SubNav if one of the action bar subnav links is active
     */
    function openSubNavFromSubNavItem() {
      //select the first active subnav item (uses .last() because jQuery)
      var $activeSubNav = $activeSubNavItem
        .parents('.action-bar__menu--sub')
        .last();

      theme.cache.$actionBarMainMenu.removeClass(showClass);
      $activeSubNav.addClass(showClass);

      // find parent menu item and mark it active
      theme.cache.$actionBarMenuHasDropdown.each(function() {
        var $el = $(this);
        var menuHandle = $el.attr('data-child-list-handle');

        if (menuHandle === $activeSubNav.attr('data-child-list-handle')) {
          $el.addClass('action-bar--disabled');

          //update the active parent childListHandle
          activeSubNavTarget = menuHandle;
        }
      });

      actionBarScroll();
    }

    function closeSubNav() {
      theme.cache.$actionBarSubMenus.removeClass(showClass);
      theme.cache.$actionBarMainMenu.prepareTransition().addClass(showClass);
      theme.setFocus(theme.cache.$actionBarMainMenuFirst, 'action-bar');
      actionBarScroll();
    }
  }

  function actionBarScroll() {
    // set dynamic variables which might have changed since the last time
    // actionBarScroll() was called
    var $activeActionBar = $('.action-bar--show');
    var activeActionBarWidth = $activeActionBar.width();
    //set action bar to be scrollable

    if (activeActionBarWidth > theme.variables.windowWidth) {
      var $activeLink = $activeActionBar.find('.action-bar--active');

      theme.cache.$actionBarWrapper.addClass('scrollable-js');

      //only scroll if a link is marked active
      if ($activeLink.length) {
        var activeOffset = $activeLink.offset().left;
        var scrollToLink = 0;

        if (activeOffset > theme.variables.windowWidth / 2) {
          scrollToLink = activeOffset - theme.variables.windowWidth / 3;

          theme.cache.$actionBar.animate({
            scrollLeft: scrollToLink
          });
        }
      }
    } else {
      theme.cache.$actionBarWrapper.removeClass('scrollable-js');
      theme.cache.$actionBar.animate({
        scrollLeft: 0
      });
    }

    theme.cache.$actionBar.on('scroll', $.throttle(100, scrollPosition));

    function scrollPosition() {
      var leftEdge = $activeActionBar.offset().left;

      // Make sure we've scrolled passed a buffer of 100px
      if (leftEdge < -100) {
        theme.cache.$actionBarWrapper.addClass('scrolled');
      } else {
        theme.cache.$actionBarWrapper.removeClass('scrolled');
      }
    }
  }

  function resizeEvents() {
    var windowWidth = theme.cache.$window.width();

    if (windowWidth === theme.variables.windowWidth) return;

    theme.variables.windowWidth = windowWidth;
    setStickyActionBarVariables();
  }

  function initStickyActionBar() {
    if (!theme.cache.$actionBar.length) {
      resizeHeader();
      return;
    }

    // if there is a slideshow we need to reset the 'top' of the page
    // to the bottom of the slideshow
    if (theme.cache.$hero.length) {
      theme.cache.$window.on('slick-initialized', function() {
        theme.cache.$heroContentWrapper.addClass('hero-initialized');
        setStickyActionBarVariables();
        stickyActionBar();
        theme.cache.$window.on('scroll', stickyActionBar);
      });
    } else {
      setStickyActionBarVariables();
      stickyActionBar();
      theme.cache.$window.on('scroll', stickyActionBar);
    }
  }

  function setStickyActionBarVariables() {
    if (!theme.cache.$actionBar.length) return;

    theme.variables.actionBarOffsetTop = theme.cache.$actionBar.offset().top;
    theme.variables.actionBarOffsetBottom =
      theme.cache.$actionBar.height() + theme.cache.$actionBar.offset().top;

    resizeHeader();
  }

  function resizeHeader() {
    var siteHeaderHeight = theme.cache.$siteHeader.height();

    // prevent content from jumping when we show/hide the header on non-index pages
    if (!theme.variables.isIndexTemplate) {
      theme.cache.$siteHeaderWrapper.css('height', siteHeaderHeight);
    }
  }

  function stickyActionBar() {
    var currentScrollTop = theme.cache.$window.scrollTop();

    // scroll down && we're below the header
    if (
      currentScrollTop > theme.variables.previousScrollPosition &&
      currentScrollTop > theme.variables.actionBarOffsetBottom
    ) {
      theme.cache.$body.addClass(theme.variables.stickyClass);

      var scrollTimeout = setTimeout(function() {
        theme.cache.$body.addClass(
          theme.variables.actionBarOpenTransitionClass
        );
      }, 50);
      theme.variables.previousScrollPosition = currentScrollTop;
    }

    // scroll Up
    if (currentScrollTop < theme.variables.previousScrollPosition) {
      clearTimeout(scrollTimeout);

      // show the regular ol' site header at the top of the page
      if (currentScrollTop <= theme.variables.actionBarOffsetTop) {
        theme.cache.$body
          .removeClass(theme.variables.stickyClass)
          .removeClass(theme.variables.actionBarOpenTransitionClass);
        theme.variables.previousScrollPosition = currentScrollTop;
      }
    }
  }

  return {
    init: init
  };
})();

theme.Collection = (function() {
  var selectors = {
    collectionGrid: '.collection-grid',
    collectionSort: '#SortBy',
    tagSort: '#SortTags',
    showMoreButton: '.js-show-more'
  };

  function init() {
    cacheSelectors();
    collectionSorting();
    tagSorting();
    initPagination();
  }

  function cacheSelectors() {
    var cache = {
      $collectionGrid: $(selectors.collectionGrid),
      $collectionSort: $(selectors.collectionSort),
      $tagSort: $(selectors.tagSort),
      $showMoreButton: $(selectors.showMoreButton)
    };

    $.extend(theme.cache, cache);
  }

  function collectionSorting() {
    theme.queryParams = {};
    var $sort = theme.cache.$collectionSort;

    if (!$sort.length) return;

    if (location.search.length) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          theme.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    // Enable sorting with current sort order as value
    $sort.val($sort.attr('data-value')).on('change', function() {
      theme.queryParams.sort_by = $(this).val();
      if (theme.queryParams.page) {
        delete theme.queryParams.page;
      }
      location.search = decodeURIComponent($.param(theme.queryParams));
    });
  }

  function tagSorting() {
    theme.cache.$tagSort.on('change', function() {
      var val = $(this).val();
      if (val) {
        window.location.href = $(this).val();
      }
    });
  }

  function initPagination() {
    if (!theme.cache.$showMoreButton.length) return;

    theme.cache.$showMoreButton.on('click', paginate);
  }

  function paginate(evt) {
    evt.preventDefault();

    // only send on ajax request at a time
    if (
      theme.cache.$showMoreButton.hasClass('btn--ajax-disabled') ||
      theme.cache.$showMoreButton.hasClass('btn--disabled')
    )
      return;

    theme.cache.$showMoreButton.addClass('btn--ajax-disabled');

    $.ajax({
      url: theme.cache.$showMoreButton.attr('href'),
      type: 'GET',
      dataType: 'html'
    })
      .done(function(data) {
        var $data = $(data);
        var $newItems = $data.find('.product-item');
        var showMoreUrl = $data.find('.js-show-more').attr('href');

        theme.cache.$collectionGrid.append($newItems);

        //update grid items selector so that the imagesLoaded plugin knows about them
        theme.cache.$productGridItem = $('.product-item');

        if (showMoreUrl.length) {
          theme.cache.$showMoreButton.attr('href', showMoreUrl);
        } else {
          theme.cache.$showMoreButton.addClass('btn--disabled');
        }
      })
      .always(function() {
        theme.cache.$showMoreButton.removeClass('btn--ajax-disabled');
      });
  }

  return {
    init: init
  };
})();

eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('"aM bd";17 7c="11"==1V 5g&&"98"==1V 5g.b2?11(t){12 1V t}:11(t){12 t&&"11"==1V 5g&&t.av===5g&&t!==5g.1y?"98":1V t};!11(t,e,i,s){17 n=e.bm;11 o(e){7.1R=e,7.24=11(){17 i;1t(7.6z="14-b4",7.6s=!0===n.8k?"14-aQ":"14-8L",7.5r=t(\'<1k 1w="\'+7.6z+\'"><1k 1w="\'+7.6s+\'"></1k></1k>"\'),-1!==e&&!0===n.8k){1t(/^#([A-aR-aV-9]{3}){1,2}$/.bz(e)){3==(i=e.45(1).3z("")).1b&&(i=[i[0],i[0],i[1],i[1],i[2],i[2]]);17 s="4l("+[(i="aS"+i.3W(""))>>16&64,i>>8&64,64&i].3W(",")+",1)";7.5r.1o("."+7.6s).1c({"2J-1d-1R":s+"0.2)","2J-2b-1R":s+"0.2)","2J-2j-1R":s+"0.2)","2J-1h-1R":s+"1)"})}17 o=/^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i.99(e);1t(o){s="4l("+3r(o[1],16)+", "+3r(o[2],16)+", "+3r(o[3],16)+", ";7.5r.1o("."+7.6s).1c({"2J-1d-1R":s+"0.2)","2J-2b-1R":s+"0.2)","2J-2j-1R":s+"0.2)","2J-1h-1R":s+"1)"})}}},7.1L=11(){12 7.5r},7.24()}11 r(i,s){7.1N="2z",7.1a=0,7.1g=0,7.2K=t(i).34("2n"),7.4U=t(i).34("4W")||"2z",7.23=t(i).2P("14-23")||"",7.36="1q",7.2A=t.4A(),7.bc=[],7.15=[],7.2R=[],7.9v=s.7H,7.2h=["2N","18","1n","1p"],7.3R=[],7.52=0,7.53=0,7.46=!1,7.5Q=s.5Q,7.24=11(){17 e=7;t.1Y(e.2h,11(i,s){5o(s){2o"1n":e.15.1u(t(\'<1k 1w="14-1n-1A"><32 2n=\'+e.2K+" 4W="+e.4U+" /></1k>"));2H;2o"18":e.15.1u(t(\'<1k 1w="14-2a-1A"><1k 1w="14-18-1A"><32 1w="14-18-18" 2n=\'+e.2K+" 4W="+e.4U+" /></1k></1k>"));2H;2o"2N":e.15.1u(t(\'<1k 1w="14-18-1A"><32 1w="14-18-18" 2n=\'+e.2K+" 4W="+e.4U+" /></1k>"));2H;2o"1p":e.15.1u(t(\'<1k 1w="14-1p-1A-18"><32 1w="14-1p-18" 2n=\'+e.2K+" 4W="+e.4U+" /></1k>"))}e.2R.1u(e.15[i].1o("32").1D()),e.3R.1u(1q o(e.5Q))}),"1q"===e.36&&(e.36="8L",e.7F(),t.3a(e.4a()).3f(11(){"7B"===e.36&&t.1Y(e.15,11(t){e.15[t].1o("32").34("2n",e.2K)}),e.7A(),e.3e(),e.2A.3s()}))},7.1L=11(e){12 7.15[t.2V(e,7.2h)]},7.8a=11(e){12 7.2R[t.2V(e,7.2h)]},7.4a=11(){17 i=7;12 t.4A(11(s){t("<32/>").1s("8o",11(){i.1a=7.1a,i.1g=7.1g,i.36="bB",s.3s()}).1s("7B",11(){1t(7.bY="",i.36="7B",n.4e){i.1a=8M,i.1g=8M;17 t=e.aN(\'<4e aP="8N://8T.8Z.94/95/4e" 1a="\'+i.1a+\'" 1g="\'+i.1g+\'"><b3 1a="\'+i.1a+\'" 1g="\'+i.1g+\'" 96="#b5"/><7y 7y-bj="bl" x="\'+i.1a/2+\'" y="\'+i.1g/2+\'" 21="96:#bC;7w-c0:cn;7w-cr:cs;7w-cA:cC,cE,cF-ah;ak-7N:aA">\'+i.9v+"</7y></4e>");i.2K="2P:2z/4e+aH;aI,"+t}s.3s()}).34("2n",i.2K)}).82()},7.3e=11(){17 e=7;t.1Y(e.2R,11(t,i){1t("18"===e.2h[t]&&e.15[t].1o(".14-18-1A").1Q("14-aO-2I"),"2N"===e.2h[t]){17 s=e.15[t].1a()/e.1a,n=e.15[t].1g()/e.1g,o=s>n?s:n;i.1a(1l.2B(e.1a*o,10)),i.1g(1l.2B(e.1g*o,10));17 r=i.1B()/2*1E/e.15[t].1B(),a=i.1F()/2*1E/e.15[t].1B();i.1c({"1C-1d":"-"+a+"%","1C-1h":"-"+r+"%"})}"1p"===e.2h[t]&&e.2R[t].2i("14-1p-18-5A 14-1p-18-5J").1Q("14-1p-18-2I")})},7.5c=11(t,e){12 7.1a<=t&&7.1g<=e},7.5d=11(e,i,s){17 n=7;t.1Y(n.2h,11(t,o){"1p"===o&&("5e"===e?n.2R[t].2i("14-1p-18-5A 14-1p-18-5J").1Q("14-1p-18-2I"):(n.2R[t].2i("14-1p-18-2I 14-1p-18-5A 14-1p-18-5J"),n.1a<=i&&n.1g<=s?n.2R[t].1Q("14-1p-18-2I"):(n.1a<=i&&n.2R[t].1Q("14-1p-18-5A"),n.1g<=s&&n.2R[t].1Q("14-1p-18-5J"))))})},7.7F=11(){17 e=7;t.1Y(e.2R,11(i,s){t(s).9B(e.3R[i].1L())})},7.7A=11(){17 e=7;t.1Y(e.15,11(i,s){t(s).1o("."+e.3R[i].6z).9G(),t(e.2R[i]).3V()})},7.24()}11 a(e,i){7.1N="3Q",7.1a=t(e).2P("14-1a")||i.7Q||0,7.1g=t(e).2P("14-1g")||i.7X||0,7.2K=t(e).34("80"),7.ct=t(e).2P("14-4m-2z")||"",7.6r=i.8c||"8e",7.36,7.15=[],7.30=[],7.2A=t.4A(),7.2h=["2N","18","1p"],7.3R=[],7.46=!1,7.24=11(){17 e=7;t.1Y(e.2h,11(i,s){e.3R.1u(1q o),"2N"===s&&(e.15.1u(t(\'<1k 1w="14-18-1A 14-2N-32"><1k 1w="14-1H 14-1H-8J"></1k><6D>\'+e.6r+"</6D></1k>")),e.30.1u(t("")),e.15[i].1Q("14-4C-2I")),"18"===s&&(e.15.1u(t(\'<1k 1w="14-2a-1A"><1k 1w="14-18-1A 14-4C-2I" 21="4G-1R: 26(0, 0, 0);"><3Q 1w="14-18-18" 8U="0" 8V 1a="1E%" 1g="1E%" 21 = "4G: #5I;"/></1k></1k>\')),e.30.1u(e.15[i].1o("3Q")),e.30[i].34("2n","//90:93"),e.15[i].1D(),t.3a(e.4a(s)).3f(11(t){e.3e(s),e.15[i].3V(),e.2A.3s()})),"1p"===s&&(e.15.1u(t(\'<1k 1w="14-1p-1A-18 14-4C-2I" 21="4G-1R: 26(0, 0, 0);"><3Q 8U="0" 8V 1a="1E%" 1g="1E%" 21 = "4G: #5I;"/></1k>\')),e.30.1u(e.15[i].1o("3Q")),e.30[i].34("2n","//90:93"),t.3a(e.4a(s)).3f(11(t){e.3e(s),e.2A.3s()}))})},7.1L=11(e,i,s){12"2N"!==e&&7.3e(e,i,s),7.15[t.2V(e,7.2h)]},7.4a=11(e){17 i=7;12 t.4A(11(s){i.30[t.2V(e,i.2h)].1s("8o",11(){s.3s()}).34("2n",i.2K)}).82()},7.3e=11(e,i,s){17 n=t.2V(e,7.2h),o={};1t(7.1g<=s&&7.1a<=i)o={1a:7.1a,1g:7.1g};2u{17 r=7.1a/7.1g;1t(7.1g>s&&7.1a<=i&&(o={1a:s*r,1g:s}),7.1g<s&&7.1a>i&&(o={1a:i,1g:i/r}),7.1g>s&&7.1a>i){o=i/s<r?r>1?{1a:i,1g:i/r}:{1a:s*r,1g:s}:r>1?{1a:s*r,1g:s}:{1a:i,1g:i/r}}}"18"===e?7.15[n].1o(".14-18-1A").1c(o):t(7.15[n]).1c(o)},7.7F=11(){17 e=7;t.1Y(e.30,11(i,s){"2N"!==e.2h[i]&&t(s).9B(e.3R[i].1L())})},7.7A=11(){17 e=7;t.1Y(e.15,11(i,s){t(s).1o("."+e.3R[i].6z).9G()})},7.2f=11(e){17 i=t.2V(e,7.2h);7.30[i].7v(),"18"===e&&7.30[i].3k(7.15[i].1o(".14-18-1A")),"1p"===e&&7.30[i].3k(7.15[i])},7.24()}11 h(e,i){7.1N="2E",7.2K=t(e).34("80"),7.1a=3r(t(e).2P("14-1a"),10)||i.9g||0,7.1g=3r(t(e).2P("14-1g"),10)||i.9n||0,7.4N=t(e).2P("14-4N")||[],7.4m=t(e).2P("14-4m")||"",7.6r=i.9w||"9A",7.15=[],7.4n=[],7.2O=[],7.36,7.2A=t.4A(),7.2h=["2N","18","1p"],7.46=!1,7.24=11(){17 e=7;t.1Y(e.2h,11(i,s){"2N"===s&&(e.15.1u(t(\'<1k 1w="14-18-1A 14-2N-32"><1k 1w="14-1H 14-1H-8J"></1k><6D>\'+e.6r+"</6D></1k>")),e.4n.1u(t("")),e.2O.1u(t("")),e.15[i].1Q("14-4C-2I")),"18"===s&&(e.15.1u(t(\'<1k 1w="14-2a-1A"><1k 1w="14-18-1A 14-4C-2I" 21 = "4G-1R: #5I;"><2E 1w="14-18-18" 9J 4a 21="1a: 1E%; 1g: 1E%;"4m="\'+e.4m+\'"/></1k></1k>\')),e.4n.1u(e.15[i].1o(".14-18-1A")),e.2O.1u(e.4n[i].1o(".14-18-18")),e.15[i].1D(),e.4N.9N(e.2K),t.1Y(e.4N,11(t,s){5o(s.3z(".").9Q()){2o"6y":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/6y" />\');2H;2o"7T":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/7U" />\');2H;2o"6E":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/6E" />\')}}),e.3e(s),e.15[i].3V(),e.2A.3s()),"1p"===s&&(e.15.1u(t(\'<1k 1w="14-1p-1A-18 14-4C-2I" 21 = "4G-1R: #5I;"><2E 1w="14-1p-18" 9J 4a 21="1a: 1E%; 1g: 1E%;"4m="\'+e.4m+\'"/></1k>\')),e.4n.1u(""),e.2O.1u(e.15[i].1o(".14-1p-18")),e.15[i].1D(),e.4N.9N(e.2K),t.1Y(e.4N,11(t,s){5o(s.3z(".").9Q()){2o"6y":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/6y" />\');2H;2o"7T":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/7U" />\');2H;2o"6E":e.2O[i].2x(\'<4r 2n="\'+s+\'" 1N="2E/6E" />\')}}),e.15[i].3V(),e.2A.3s())})},7.1L=11(e,i,s){12"2N"!==e&&7.3e(e,i,s),7.15[t.2V(e,7.2h)]},7.3e=11(e,i,s){17 n=t.2V(e,7.2h),o={};1t(7.1g<=s&&7.1a<=i)o={1a:7.1a,1g:7.1g};2u{17 r=7.1a/7.1g;1t(7.1g>s&&7.1a<=i&&(o={1a:s*r,1g:s}),7.1g<s&&7.1a>i&&(o={1a:i,1g:i/r}),7.1g>s&&7.1a>i){o=i/s<r?r>1?{1a:i,1g:i/r}:{1a:s*r,1g:s}:r>1?{1a:s*r,1g:s}:{1a:i,1g:i/r}}}"18"===e?7.4n[n].1c(o):t(7.15[n]).1c(o)},7.2f=11(e){17 i=t.2V(e,7.2h);7.2O[i].7v(),"18"===e&&7.2O[i].3k(7.4n[i]),"1p"===e&&7.2O[i].3k(7.15[i])},7.24()}11 c(o,r){7.13=r,7.1a=o.4k,7.1g=o.5D,7.7u=1E,7.5m=o.5m,7.5k=o.5k,7.8p=o.8q,7.8r=o.8s,7.8w=o.8z,7.8B=o.8G,7.8H=o.8I,7.4F=o.4F,7.5R=o.5R,7.5j=t(\'<1k 1w="14-18-3l"><1k 1w = "14-18-3l-1A"><1k 1w="14-1H 14-1H-8S"></1k><1k 1w="14-1H 14-1H-2l"></1k><1k 1w="14-1H 14-1H-3S"></1k></1k></1k>\'),7.15=7.5j.1o(".14-18-3l-1A"),7.1O=1q 11(e,i){7.13=i,7.4i=e.4i,7.5h=e.5h,7.15=t(\'<1k 1w="14-1O-1A"><1k 1w="14-1O-18"></1k></1k>\'),7.18=7.15.1o(".14-1O-18"),7.5f=0,7.2L={1h:0,1d:0},7.2S={1h:0,1d:0},7.24=11(){7.18.1D(),7.2L={1h:0,1d:0},7.2S={1h:0,1d:0},7.5f=0},7.2q=11(e,i){17 s=1l.3F(e.1n.15.1B()/i.1a*1E),n=1l.3F(t(e.18[7.13.19.1f]).1B()*s/1E),o=1l.3F(e.1n.15.1F()/i.1g*1E),r=1l.3F(t(e.18[7.13.19.1f]).1F()*o/1E),a=t(e.18[7.13.19.1f]).1F(),h=t(e.18[7.13.19.1f]).1B();7.15.1c({1a:h,1g:a}),7.15.1c({1d:t(e.18[7.13.19.1f]).1x().1d,1h:t(e.18[7.13.19.1f]).1x().1h}),7.18.1c({1a:n,1g:r}),"2v"!==e.1n.1x&&!0!==e.1n.3u||e.1n.15.3k(7.15)},7.1L=11(){12 7.15},7.4J=11(){17 t=7,e={1h:0,1d:0},i={1h:0,1d:0};e={1d:t.2L.1d-t.2S.1d,1h:t.2L.1h-t.2S.1h},i={1d:-e.1d/(t.5h/1E),1h:-e.1h/(t.5h/1E)},t.2S={1d:t.2S.1d-i.1d,1h:t.2S.1h-i.1h},e.1d<1&&e.1d>-1&&(t.2S.1d=t.2L.1d),e.1h<1&&e.1h>-1&&(t.2S.1h=t.2L.1h),t.18.1c({1d:t.2S.1d,1h:t.2S.1h}),t.5f=3t(11(){t.4J()},25)},7.24()}(o,r),7.1n=1q 11(i,s){7.13=s,7.1x=i.9F,7.5U=i.5U,7.4p=i.9K,7.4g=i.4g,7.5b=i.5b,7.5a=i.7I,7.1a=i.7J,7.1g=i.7M,7.6i=i.7O,7.1C=i.7P,7.59=i.59,7.15=t(\'<1k 1w = "14-1n-3l"/>\'),7.3u=!1,7.2A=t.4A(),7.36="7R",7.24=11(){7.15.1D(),7.1A=7.15.1o(".14-1n-1A"),7.18=7.1A.1o("32"),"2v"===7.1x&&(7.5a=!0,7.1a=0,7.1g=0),7.6q=!1,7.2U={1h:0,1d:0},7.31={1h:0,1d:0},7.6v=0},7.2q=11(){7.1A.7v(),7.15.2x(7.13.1r[7.13.19.1f].1L("1n")),7.1A=7.15.1o(".14-1n-1A"),7.18=7.1A.1o("32"),7.83()},7.83=11(){"2v"!==7.1x&&(7.3u=!1,7.15.3k(7.13.1U).2i("14-1n-2v")),"2v"!==7.1x&&!0!==7.3u||7.15.3k(7.13.18.1K[7.13.19.1f]).1Q("14-1n-2v");1j(17 i=2*1J(7.15.1c("2J-1h-1a"))||0,s=2*1J(7.15.1c("8n-1d"))||0,n="2v"===7.1x?s:i+s,o="2v"===7.1x?s:i+s,r=0;r<2&&(7.5a&&7.1a>0?n+=7.1a<7.13.1r[7.13.19.1f].1a?7.1a:7.13.1r[7.13.19.1f].1a:n+=t(7.13.18.18[7.13.19.1f]).1B(),7.5a&&7.1g>0?o+=7.1g<7.13.1r[7.13.19.1f].1g?7.1g:7.13.1r[7.13.19.1f].1g:o+=t(7.13.18.18[7.13.19.1f]).1F(),!1===7.5a&&!1===7.3u&&(n=o),!0===7.5U&&"2v"!==7.1x)&&7.13.1U.1B()+n>t(e).1a()&&(7.3u=!0,0===r&&(n=o=s),"2v"!==7.1x);r++);1t(7.1A.1c({1a:0,1g:0}),7.15.1c({1a:n,1g:o}),7.1A.1c({1a:7.15.1B(),1g:7.15.1F()}),"2v"===7.1x||!0===7.3u)7.15.3k(7.13.18.1K[7.13.19.1f]).1Q("14-1n-2v");2u{7.15.3k(7.13.1U).2i("14-1n-2v"),"1h"===7.1x?7.15.1c({2b:7.13.1U.1B(!0),"1C-2b":7.1C+"5u"}):7.15.1c({1h:7.13.1U.1B(!0),"1C-1h":7.1C+"5u"});17 a="cw"===7.6i?0:t(7.13.18.1K[7.13.19.1f]).1x().1d+1J(t(7.13.18.1K[7.13.19.1f]).1c("1C-1d"));1t("1d"===7.13.19.1x){17 h=7.13.19.15.1F()+1J(7.13.19.1C);7.15.1c({1d:a+h})}2u 7.15.1c({1d:a})}},7.2r=11(){7.2q(),!0===7.59&&7.23.2q(),7.2A.3s()},7.1L=11(){12 7.15},7.4J=11(){17 t=7,e={1h:0,1d:0},i={1h:0,1d:0};e={1d:t.2U.1d-t.31.1d,1h:t.2U.1h-t.31.1h},i={1d:-e.1d/(t.5b/1E),1h:-e.1h/(t.5b/1E)},t.31={1d:t.31.1d-i.1d,1h:t.31.1h-i.1h},e.1d<1&&e.1d>-1&&(t.31.1d=t.2U.1d),e.1h<1&&e.1h>-1&&(t.31.1h=t.2U.1h),t.18.1c({1d:t.31.1d,1h:t.31.1h}),t.6v=3t(11(){t.4J()},25)},7.24()}(o,r),!0===7.1n.59&&(7.1n.23=1q 11(e,i){7.1n=i,7.56=e.7t,7.5C=e.7q,7.7p=e.7o,7.15=t(\'<1k 1w="14-23-1A"><1k></1k></1k>\'),7.18=7.15.1o("1k"),7.24=11(){17 e="14-23-"+7.56+7.5C;"2v"===7.1n.1x&&(7.56="2c"),-1===t.2V(e,["14-23-7n","14-23-7m","14-23-5M","14-23-5O"])&&(e="14-23-"+7.1n.13.2e.7t+7.1n.13.2e.7q),-1===t.2V(7.7p,["1h","2b","2I"])?e+=" 14-6i-"+7.1n.13.2e.7o:e+=" 14-6i-"+7.7p,7.15.1Q(e).3k(7.1n.15)},7.2q=11(){17 t=7.1n.13.1r[7.1n.13.19.1f].23;""===t?7.15.1D():(7.15.2Y(),7.18.8P().2x(t)),!0===7.1n.3u?"5T"===7.56&&7.15.2i("14-23-7n 14-23-7m").1Q("1d"===7.5C?"14-23-5M":"14-23-5O"):"5T"===7.56&&(7.15.7k("14-23-5M")||7.15.7k("14-23-5O"))&&7.15.2i("14-23-5M 14-23-5O").1Q("1d"===7.5C?"14-23-7n":"14-23-7m")},7.1L=11(){12 7.15},7.24()}(o,7.1n)),7.24=11(){1t(7.2C=7.15.1o(".14-1H-3S"),7.2D=7.15.1o(".14-1H-2l"),7.4b=7.15.1o(".14-1H-8S"),1!==7.13.1U.1o("1z").1b&&!1!==7.5m||(7.2C.1D(),7.2D.1D(),7.4b.1D()),7.2X={x:-1,y:-1},7.7j="5T",7.6n=!1,7.4I=0,7.3m=!1,7.29={x:0,y:0},7.28={x:0,y:0},7.7h="",7.9k=n.9m,!1===7.4F||!1===7.9k)7.4b.1Q("14-1D");2u{17 t={1d:"",2j:"",2b:"",1h:""},e="-"+7.5j.1c("2J-1h-1a");5o(7.5R){2o 1:t.1d=e,t.1h=e;2H;2o 2:t.1d=e,t.2b=e;2H;2o 4:t.2j=e,t.2b=e;2H;9s:t.2j=e,t.1h=e}7.4b.1c(t)}},7.3I=11(){17 e=7;e.15.1s("3q.9y",11(){e.6n=!0}).1s("3K.9y",11(){e.6n=!1}),t(e.1O.1L()).1s("5t.1v",t.1M(e.9H,e)).1s("3q.1v",t.1M(e.7g,e)).1s("3q.1v",t.1M(e.8p,e)).1s("3K.1v",t.1M(e.5z,e)).1s("3K.1v",t.1M(e.8r,e)).1s("48.1v",t.1M(e.3g,e)).1s("3T.1v",t.1M(e.3h,e)).1s("47.1v",t.1M(e.3j,e)),!1===e.5m&&e.13.19.1z.1b>1&&e.15.1s("3q.5H",t.1M(e.4o,e,"2Y","3q")).1s("3K.5H",t.1M(e.4o,e,"1D","3K")).1s("5t.5H",11(t){e.4o("2Y"),35(e.4I),e.4I=3t(11(){e.4o("1D")},e.5k)}).1s("3T.5H",11(t){e.4o("2Y"),35(e.4I),e.4I=3t(11(){e.4o("1D")},e.5k),!0===e.1n.4p&&t.4z()}),!0===e.13.1p.4p&&t.1Y(e.13.1r,11(i,s){t.3a(s.7f).3f(11(){"2E"===s.1N?t(s.1L("18")).1s("2p.1v",11(t){e.13.1p.3w()}).1o("2E").1s("2p.1v",11(t){12!1}):t(s.1L("18")).1s("2p.1v",11(t){e.13.1p.3w()})})}),e.2C.1s("2p.1v",11(){e.2f("3p")}),e.2D.1s("2p.1v",11(){e.2f("2l")}),e.4b.1s("2p.1v",11(){17 s=i.7G("9m");s.1a=e.13.1r[e.13.19.1f].1a,s.1g=e.13.1r[e.13.19.1f].1g;17 n=s.b6("2d"),o=e.15.1o(".14-18-18")[e.13.19.1f];n.b7(o,0,0);1q b8;s.b9(11(e){ba(e,t(o).34("2n").81(/^.*[\\\\\\/]/,""))},"2z/bi")}),!0===e.8w&&(e.5S("4H"),!0===e.8H&&e.15.1s("3q.1v",t.1M(e.5S,e,"3N")).1s("3K.1v",t.1M(e.5S,e,"4H")))},7.2q=11(e){17 i=7;e=i.13.1U.1B();17 s=i.7u*e/1E,n=s*i.1g/i.1a;i.5j.1c({1g:"0",1a:"0"}).1c({1g:1l.2B(n),1a:1l.2B(s)}),t.1Y(i.13.1r,11(t,e){i.15.2x(i.13.1r[t].1L("18",1l.2B(s),1l.2B(n)))}),i.2g=i.15.1o(".14-2a-1A"),t(i.2g[i.13.19.1f]).1Q("14-2a-1A-1f"),i.1K=i.2g.1o(".14-18-1A"),i.18=i.1K.1o(".14-18-18"),t.1Y(i.13.1r,11(e,s){t.3a(s.2A).3f(11(){"2z"===s.1N&&(i.7b(e,s),i.7b(e,s))})}),i.2C.1c("1C-1d",-i.2C.1F()/2),i.2D.1c("1C-1d",-i.2D.1F()/2)},7.8f=11(){17 e=7;t.3a(e.13.1r[e.13.19.1f].2A).3f(11(){!1!==e.13.1r[e.13.19.1f].46?"2z"===e.13.1r[e.13.19.1f].1N&&(t(e.1K[e.13.19.1f]).2x(e.1O.1L()),e.1n.2r(),t.3a(e.1n.2A).3f(11(){e.1O.2q(e,e.13.1r[e.13.19.1f]),e.8i()&&!0===e.6n?e.7g():e.5z()})):e.5z()})},7.7b=11(e,i){17 s,n,o;t(7.1K[e]).1c({1a:"0",1g:"0"}).1c({1a:7.15.1a(),1g:7.15.1g()}),i.52=t(7.1K[e]).1B()/i.1a,i.53=t(7.1K[e]).1F()/i.1g,i.52<1||i.53<1?(i.46=!0===7.1n.4p,s=i.52<i.53?i.52:i.53):(i.46=!1,s=1),n=s*i.1a,o=s*i.1g,"2z"===7.13.1r[e].1N&&t(7.18[e]).1c({1a:n,1g:o}),t(7.1K[e]).1c({1a:n,1g:o});17 r=2*1J(7.15.1c("2J-1h-1a")),a=2*1J(7.15.1c("8n-1d")),h=t(7.1K[e]).1B()/2*1E/(7.15.1B()-r-a),c=t(7.1K[e]).1F()/2*1E/(7.15.1B()-r-a);t(7.1K[e]).1c({"1C-1h":"-"+h+"%","1C-1d":"-"+c+"%"})},7.1L=11(){12 7.5j},7.9H=11(t,e){e!==s&&(t=e),t!==s&&(7.2X=!0===7.3m&&1===t.1W.1X.1b?{x:t.1W.1X[0].2Q,y:t.1W.1X[0].2T}:{x:t.2Q,y:t.2T}),-1===7.2X.x&&-1===7.2X.y||(7.6G(),(!1===7.1n.4g||!0===7.1n.4g&&t===s)&&7.1n.18.1c({1d:7.1n.2U.1d,1h:7.1n.2U.1h}),(!1===7.1O.4i||!0===7.1O.4i&&t===s)&&7.1O.18.1c({1d:7.1O.2L.1d,1h:7.1O.2L.1h}))},7.7g=11(t,e){!1!==7.13.1r[7.13.19.1f].46&&(e!==s&&(t=e),7.1n.36="7R",t!==s&&(7.2X=!0===7.3m&&1===t.1W.1X.1b?{x:t.1W.1X[0].2Q,y:t.1W.1X[0].2T}:{x:t.2Q,y:t.2T}),7.6G(),7.1n.31={1d:7.1n.2U.1d,1h:7.1n.2U.1h},7.1n.18.1c({1d:7.1n.2U.1d,1h:7.1n.2U.1h}),7.1O.2S={1d:7.1O.2L.1d,1h:7.1O.2L.1h},7.1O.18.1c({1d:7.1O.2L.1d,1h:7.1O.2L.1h}),!1===7.1n.6q&&("2v"===7.1n.1x||!0===7.1n.3u?7.1n.15.3V(7.13.1S.51):(7.1O.18.3V(7.13.1S.51),7.1n.15.3V(7.13.1S.51))),!0===7.1n.4g&&(35(7.1n.6v),7.1n.4J()),!0===7.1O.4i&&(35(7.1O.5f),7.1O.4J()),7.1n.6q=!0)},7.5z=11(t,e){7.1O.18.3N().1D(),7.1n.15.3N().8t(7.13.1S.51),7.1n.36="cD",e!==s&&(t=e),t!==s&&(7.2X=!0===7.3m&&1===t.1W.1X.1b?{x:t.1W.1X[0].2Q,y:t.1W.1X[0].2T}:{x:t.2Q,y:t.2T}),!0===7.1n.4g&&35(7.1n.6v),!0===7.1O.4i&&35(7.1O.5f),7.1n.6q=!1},7.3g=11(t){t.4z()},7.3h=11(e){!1===7.3m&&(7.3m=!0,t(7.1O.1L()).79("3q.1v",e)),t(7.1O.1L()).79("5t.1v",e),e.4z()},7.3j=11(e){!0===7.3m?(t(7.1O.1L()).79("3K.1v",e),7.3m=!1):7.13.1p.3w(),e.4z()},7.6G=11(){17 e=t(7.15).8x(),i=t(7.1K[7.13.19.1f]).1x(),s=7.2X.x-(e.1h+i.1h+1J(t(7.1K[7.13.19.1f]).1c("1C-1h"))),n=7.2X.y-(e.1d+i.1d+1J(t(7.1K[7.13.19.1f]).1c("1C-1d"))),o=t(7.18[7.13.19.1f]).1F(),r=t(7.18[7.13.19.1f]).1B(),a=7.1O.18.1B(),h=7.1O.18.1F(),c=n-1l.3F(h/2),l=s-1l.3F(a/2),u=7.13.1r[7.13.19.1f].1a/r,p=-c*u,d=-l*u;n-h/2<0&&(c=0,p=0),n+h/2>0+o&&(c=o-h,p=-(7.13.1r[7.13.19.1f].1g-7.1n.15.1F())),s-a/2<0&&(l=0,d=0),s+a/2>0+r&&(l=r-a,d=-(7.13.1r[7.13.19.1f].1a-7.1n.15.1B())),7.1n.2U={1d:p,1h:d},7.1O.2L={1d:c,1h:l}},7.8i=11(){17 e=t(7.15).8x(),i=t(7.1K[7.13.19.1f]).1x(),s=7.2X.x-(e.1h+i.1h+1J(t(7.1K[7.13.19.1f]).1c("1C-1h"))),n=7.2X.y-(e.1d+i.1d+1J(t(7.1K[7.13.19.1f]).1c("1C-1d"))),o=t(7.18[7.13.19.1f]).1B(),r=t(7.18[7.13.19.1f]).1F();12 s>=0&&n>=0&&s<=o&&n<=r},7.2f=11(t,e){17 i=e||7;i.13.19.2f(t),i.13.2r()},7.2r=11(){17 e=7,i=e.2g[e.13.19.2s],s=e.2g[e.13.19.1f],n=e.13.19.2s===e.13.1r.1b-1&&0===e.13.19.1f,o=0===e.13.19.2s&&e.13.19.1f===e.13.1r.1b-1;e.13.19.2s,e.13.19.1f;e.8f(),1Z.44(i,{2w:0},{1N:1Z.3i,3c:1E,3v:11(){1Z.1c(i,{2w:0,4K:"78"}),"2z"!==e.13.1r[e.13.19.2s].1N&&e.13.1r[e.13.19.2s].2f("18")}}),1Z.1c(s,{2w:1}),e.2g.2i("14-2a-1A-1f"),t(s).1Q("14-2a-1A-1f"),1Z.44(s,{2w:1},{1N:1Z.3i,3c:1E,3v:11(){1Z.1c(s,{2w:1,4K:"5w"})}})},7.4o=11(t,e,i){i!==s&&(7.2X=!0===7.3m&&1===i.1W.1X.1b?{x:i.1W.1X[0].2Q,y:i.1W.1X[0].2T}:{x:i.2Q,y:i.2T}),"3K"===e&&(7.7j="5T"),"3q"===e&&(7.7j="2c"),"1D"===t?(7.2C.1D(),7.2D.1D(),!0===7.4F&&7.4b.1D()):(7.2C.2Y(),7.2D.2Y(),!0===7.4F&&7.4b.2Y())},7.5S=11(t){"3N"===t?aT(7.7h):7.7h=aU(7.2f,7.8B,"2l",7)},7.24()}11 l(i,s){7.2e={4k:77,5D:aX,aZ:!0,b0:!0,4F:!1,5R:3,5m:!1,5k:8W,8q:11(){},8s:11(){},8z:!1,8G:8W,8I:!0,8X:"2j",1T:5,3M:!0,3d:!1,3x:0,4q:"-1",76:4,5F:!1,4Y:"cN",9F:"2b",5U:!0,9K:!0,4g:!1,5b:be,7I:!1,7J:0,7M:0,7O:"bg",7P:4,4i:!1,5h:bh,9a:!0,9b:!1,51:77,9f:!0,4X:"-1",5Q:"-1",7H:"bo by",59:!0,7t:"2c",7q:"2j",7o:"2I",7Q:9h,7X:9i,8c:"8e",9g:9h,9n:9i,9w:"9A"},7.1U=i.9j(\'<1k 1w="bX-2o"></1k>\').4v(),7.1S=t.9l(!0,{},7.2e,s),7.4w=s,7.1r=[],7.74=t(e).1a(),7.9o()}11 u(){}u.1y={9q:11(e,i){5o(t(e).1o(":9r").2P("14-1N")){2o"3Q":u.1y.5K=a;2H;2o"2E":u.1y.5K=h;2H;2o"2z":9s:u.1y.5K=r}12 1q 7.5K(t(e).1o(":9r"),i)}},l.1y={9o:11(){7.9t(),7.24(),7.2q(),7.2r(),7.3I()},9t:11(){17 e=7,i=1q u;e.1U.1o("1z").1Y(11(){e.1r.1u(i.9q(t(7),e.1S))}),e.1U.1o("1z").8P(),t.1Y(e.1U.1o("1z"),11(i,s){t(s).2x(e.1r[i].1L("2N"))})},24:11(){7.18=1q c(7.1S,7),7.19=1q 11(e,i){7.13=i,7.1x=e.8X,7.1T=e.1T,7.3M=e.3M,7.3d=e.3d,7.3x=e.3x?e.3x:0,7.4q=e.4q,7.1C=e.76,7.5F=e.5F,7.4Y=e.4Y,7.24=11(){17 t="2b"===7.1x||"1h"===7.1x?"-9u":"",e=\'<1k 1w="14-19-3l-3S"><1k 1w="14-1H 14-1H-3S\'+t+\'"></1k></1k><1k 1w="14-19-3l-2l"><1k 1w="14-1H 14-1H-2l\'+t+\'"></1k></1k>\';7.2m=7.13.1U.1o("2m"),7.2m.2i("14-4H"),7.2m.9j(\'<1k 1w="14-19-3l"></1k>\'),7.1z=7.2m.1o("1z"),7.15=7.2m.4v(),7.15.2x(e),7.3A=7.15.1o(".14-19-3l-3S"),7.2C=7.3A.1o(".14-1H-3S"+t),7.3B=7.15.1o(".14-19-3l-2l"),7.2D=7.3B.1o(".14-1H-2l"+t),7.1f=0,7.2s=0,"1h"===7.1x||"2b"===7.1x?7.15.1Q("14-9u"):7.15.1Q("14-ai"),1J(7.3x)>-1&&1J(7.3x)<=7.1z.1b-1&&(7.1f=7.3x,7.2s=7.3x),7.2Z=1l.4V(7.1f/7.1T),7.4D=7.1f,7.29={x:0,y:0},7.28={x:0,y:0}},7.2q=11(){17 t=7.13.18.1L();1t(!1===7.3d&&1===7.1z.1b)12 7.15.1F(0),22 7.15.1Q("14-1D");7.3d=!0,"2b"===7.1x&&(7.73(),t.1c({1d:"0",1h:"0"}),7.15.1c({1d:"0",1h:t.1B()+7.1C})),"1h"===7.1x&&(7.73(),7.15.1c({1d:"0",1h:"0"}),t.1c({1d:"0",1h:7.15.1B()+7.1C})),"2j"===7.1x&&(7.72(),t.1c({1d:"0",1h:"0"}),7.15.1c({1d:t.1F()+7.1C,1h:"0"})),"1d"===7.1x&&(7.72(),7.15.1c({1d:"0",1h:"0"}),t.1c({1d:7.15.1F()+7.1C,1h:"0"})),1J(7.3x)>0&&7.2Z>0&&(7.2Z-=1,7.2a("40",""))},7.73=11(){17 t=7.13.18.1L();7.15.1c("1g",t.1F());17 e=1J(7.1z.1c("1C-2j")),i=7.13.18.1a/7.13.18.1g,s=7.15.1F()/7.1T-(7.1T-1)*e/7.1T,n=s*i,o=1E*s/((s+e)*7.1z.1b-e);1t(7.1z.1c({1a:n,1g:o+"%"}),7.1z.9M().1c("1C-2j",0),7.2m.1c({1a:1l.2B(n),1g:1l.2B((s+e)*7.1z.1b-e)}),7.15.1c("1a",1l.2B(n)),7.3A.2i("14-1D"),7.2C.1c("1C-1h",-7.2C.1B()/2),7.3B.2i("14-1D"),7.2D.1c("1C-1h",-7.2D.1B()/2),7.5Y(),7.13.71){17 r=7.1z.1F(),a=7.15.1F()-(r*7.1T+(7.1T-1)*e);7.2m.1o(":60-62("+7.1T+"n)").1c("1g",r+a)}},7.72=11(){17 t=7.13.18.1L();7.15.1c("1a",t.1B());17 e,i=1J(7.1z.1c("1C-2b")),s=7.13.18.1a/7.13.18.1g,n=7.15.1B()/7.1T-(7.1T-1)*i/7.1T,o=n/s;1t(e=!0===7.3M?1E*n/((n+i)*7.1z.1b-i):1E*n/7.15.1B(),7.1z.1c({1a:e+"%",1g:o}),!0===7.3M?7.1z.9M().1c("1C-2b",0):(7.2m.1o(":60-62("+7.1T+"n)").1c("1C-2b",0),7.2m.1o(":60-62(n +"+(1J(7.1T)+1)+")").1c("1C-1d",i+"5u")),!0===7.3M)7.2m.1c({1a:1l.2B(n*7.1z.1b+(7.1z.1b-1)*i),1g:1l.2B(o)}),7.15.1c("1g",1l.2B(o));2u{17 r=1l.2B(7.1z.1b/7.1T),a=1l.2B(o*r+i*(r-1));7.2m.1c({1a:7.15.1B(),1g:a}),7.15.1c("1g",a)}1t(!0===7.3M?(7.3A.2i("14-1D"),7.2C.1c("1C-1d",-7.2C.1F()/2),7.3B.2i("14-1D"),7.2D.1c("1C-1d",-7.2D.1F()/2),7.5Y()):(7.3A.1Q("14-1D"),7.3B.1Q("14-1D")),7.13.71){17 h=7.1z.1B(),c=7.15.1B()-(h*7.1T+(7.1T-1)*i);7.2m.1o(":60-62("+7.1T+"n)").1c("1a",h+c)}},7.5Y=11(){1t(7.1z.1b<=7.1T)12 7.3A.1Q("14-1D"),22 7.3B.1Q("14-1D");7.3A.2i("14-4S"),7.3B.2i("14-4S"),"7K"!==7.4Y&&(0===7.2Z&&7.3A.1Q("14-4S"),7.2Z===1l.4V((7.1z.1b-1)/7.1T)&&7.3B.1Q("14-4S"))},7.2r=11(){-1!==7.4q&&7.2m.1o(".14-65").1c("2J-1R",""),7.1z.2i("14-65").aW(7.1f).1Q("14-65"),-1!==7.4q&&7.2m.1o(".14-65").1c("2J-1R",7.4q),7.2a("70","")},7.1L=11(){12 7.15},7.3I=11(){17 e=7;e.1z.1s("2p.1v",11(){e.6Z(t(7).3o())}),!0===e.5F&&e.1z.1s("3q",11(){e.6Z(t(7).3o())}),e.3A.1s("2p.1v",11(){e.2a("40","3p")}),e.3B.1s("2p.1v",11(){e.2a("40","2l")}),e.2m.1s("48.1v",t.1M(e.3g,e)).1s("3T.1v",t.1M(e.3h,e)).1s("47.1v",t.1M(e.3j,e))},7.3g=11(t){1===t.1W.1X.1b&&(7.29.x=t.1W.1X[0].2Q,7.28.x=7.29.x,7.29.y=t.1W.1X[0].2T,7.28.y=7.29.y)},7.3h=11(t){1===t.1W.1X.1b&&(7.28.x=t.1W.1X[0].2Q,7.28.y=t.1W.1X[0].2T)},7.3j=11(t){7.28.x===7.29.x&&7.28.y===7.29.y||(t.4z(),"2b"===7.1x||"1h"===7.1x?(7.29.y-7.28.y>10&&7.2a("40","2l"),7.29.y-7.28.y<-10&&7.2a("40","3p")):(7.29.x-7.28.x>10&&7.2a("40","2l"),7.29.x-7.28.x<-10&&7.2a("40","3p")))},7.2a=11(t,e){17 i,s,n=7,o=0,r=0;1t(!1!==n.3M||"2j"!==n.1x&&"1d"!==n.1x){1t(i={1N:1Z.3i,3c:b1,6Y:11(){n.5Y()}},"7K"===n.4Y)r="70"===t?n.1f:"3p"===e?n.4D>0?n.4D-1:n.1z.1b-1:n.4D+1>n.1z.1b-1?0:n.4D+1,n.4D=r,s="2j"===n.1x||"1d"===n.1x?{1h:-r*(n.1z.1B()+1J(n.1z.1c("1C-2b")))}:{1d:-r*(n.1z.1F()+1J(n.1z.1c("1C-2j")))};2u{1t((o="70"===t?1l.4V(n.1f/n.1T):"3p"===e?n.2Z>0?n.2Z-1:0:n.2Z+1>1l.4V((n.1z.1b-1)/n.1T)?1l.4V((n.1z.1b-1)/n.1T):n.2Z+1)===n.2Z)12;n.2Z=o,s="2j"===n.1x||"1d"===n.1x?{6c:-o*(n.15.1B()+1J(n.1z.1c("1C-2b")))}:{6d:-o*(n.15.1F()+1J(n.1z.1c("1C-2j")))}}1Z.44(n.2m[0],s,i)}},7.6Z=11(t){7.1f!==t&&(7.2s=7.1f,7.1f=t,7.13.2r())},7.2f=11(t){7.2s=7.1f,7.1f="2l"===t?7.1f===7.1z.1b-1?0:7.1f+1:0===7.1f?7.1z.1b-1:7.1f-1},7.24(i)}(7.1S,7),7.1p=1q 11(e,i){7.13=i,7.4p=e.9a,7.6h=e.9b,7.4R=!1,7.3X="",7.15=t(\'<1k 1w="14-1p-3l"><1k 1w="14-1p-1d-6X"><1k 1w="14-1H 14-1H-4Q">&54;</1k><1k 1w="14-1H 14-1H-85">&54;</1k><1k 1w="14-1H 14-1H-86">&54;</1k></1k><1k 1w="14-1p-1h-6X"><1k 1w="14-1H 14-1H-3S">&54;</1k></1k><1k 1w="14-1p-2b-6X"><1k 1w="14-1H 14-1H-2l">&54;</1k></1k><1k 1w="14-1p-6p"><1k 1w="14-1p-1A" /></1k></1k>\'),7.24=11(){17 e=7;e.6p=e.15.1o(".14-1p-6p"),e.2g=e.6p.1o(".14-1p-1A"),t.1Y(e.13.1r,11(t,i){e.2g.2x(e.13.1r[t].1L("1p",e.2g.1a(),e.2g.1g()))}),e.1K=e.2g.1o(".14-1p-1A-18"),e.18=e.1K.1o(".14-1p-18"),e.2C=e.15.1o(".14-1H-3S"),e.2D=e.15.1o(".14-1H-2l"),e.8b=e.15.1o(".14-1H-4Q"),e.3E=e.15.1o(".14-1H-85"),e.3y=e.15.1o(".14-1H-86"),e.29={x:0,y:0},e.28={x:0,y:0},e.15.1D(),e.3E.1D(),e.3y.1D()},7.2q=11(){17 e=7;1t(t.1Y(e.13.1r,11(t,i){e.2g.2x(e.13.1r[t].1L("1p",e.2g.1a(),e.2g.1g()))}),"2z"!==e.13.1r[e.13.19.1f].1N)12 e.3y.1D(),22 e.3E.1D();e.13.1r[e.13.19.1f].5c(e.15.1B(),e.15.1F())||e.6h?(e.3y.1D(),e.3E.1D(),e.13.1r[e.13.19.1f].5d("4P",t(e.1K[e.13.19.1f]).1B(),t(e.1K[e.13.19.1f]).1F())):"6t"===e.3X?(e.3y.2Y(),e.3E.1D(),e.13.1r[e.13.19.1f].5d("4P",t(e.1K[e.13.19.1f]).1B(),t(e.1K[e.13.19.1f]).1F())):(e.3X="6W",e.3y.1D(),e.3E.2Y(),e.13.1r[e.13.19.1f].5d("5e",t(e.1K[e.13.19.1f]).1B(),t(e.1K[e.13.19.1f]).1F()))},7.2r=11(e){17 i=7,s=i.1K[i.13.19.2s],n=i.1K[i.13.19.1f];i.13.19.2s===i.13.1r.1b-1&&i.13.19.1f,0===i.13.19.2s&&(i.13.19.1f,i.13.1r.1b);1t(i.13.19.2s,i.13.19.1f,i.4R){1t(t.3a(i.13.1r[i.13.19.1f].2A).3f(11(){i.2q()}),"8m"===e)12"2E"!==i.13.1r[i.13.19.1f].1N&&"3Q"!==i.13.1r[i.13.19.1f].1N||i.13.1r[i.13.19.1f].2f("18"),1Z.1c(n,{2w:0}),22 1Z.44(n,{2w:1},{1N:1Z.3i,3c:1E,3v:11(){1Z.1c(n,{2w:1,4K:"5w"}),i.1K.2i("14-2a-1A-1f"),t(n).1Q("14-2a-1A-1f")}});1Z.44(s,{2w:0},{1N:1Z.3i,3c:1E,3v:11(){1Z.1c(s,{2w:0,4K:"78"}),"2z"!==i.13.1r[i.13.19.2s].1N&&i.13.1r[i.13.19.2s].2f("1p")}}),1Z.1c(n,{2w:1,4K:"5w"}),1Z.1c(n,{2w:0}),1Z.44(n,{2w:1},{1N:1Z.3i,3c:1E,3v:11(){i.1K.2i("14-2a-1A-1f"),t(n).1Q("14-2a-1A-1f")}})}},7.1L=11(){12 7.15},7.3I=11(){17 e=7;e.8b.1s("2p.1v",11(){e.3w()}),e.2g.1s("2p.1v",11(){e.3w()}),e.6h||(t.1Y(e.13.1r,11(i,s){"2z"===s.1N&&t.3a(s.7f).3f(11(){t(s.1L("1p")).1s("bn.1v",11(){e.6w("3w")}),t(s.8a("1p")).1s("2p.1v",11(t){t.bq()})})}),e.3E.1s("2p.1v",11(){e.6w("4P")}),e.3y.1s("2p.1v",11(){e.6w("5e")})),e.2C.1s("2p.1v",11(){e.2f("3p")}),e.2D.1s("2p.1v",11(){e.2f("2l")}),!1===e.6h&&e.2g.1s("48.1v",t.1M(e.3g,e)).1s("3T.1v",t.1M(e.3h,e)).1s("47.1v",t.1M(e.3j,e)),t.1Y(e.13.1r,11(e,i){"2z"===i.1N&&t.3a(i.7f).3f(11(){t(i.1L("1p")).1s("5t.1v",11(e){t(7).br(e.bs).bv(e.bw)})})})},7.3g=11(t){1===t.1W.1X.1b&&(7.29.x=t.1W.1X[0].2Q,7.28.x=7.29.x,7.29.y=t.1W.1X[0].2T,7.28.y=7.29.y)},7.3h=11(t){1===t.1W.1X.1b&&(7.28.x=t.1W.1X[0].2Q,7.28.y=t.1W.1X[0].2T)},7.3j=11(t){7.28.x===7.29.x&&7.28.y===7.29.y||(t.4z(),7.29.x-7.28.x>10&&7.2f("2l"),7.29.x-7.28.x<-10&&7.2f("3p"))},7.3w=11(e){17 i=7;1t(t("43").7k("14-6V"))i.4Q();2u{1t("bA"===e)12;i.15.3V(6U,11(){i.4R=!0,i.2r("8m")}),t("43").1Q("14-6V")}},7.4Q=11(){17 e=7;"2E"!==e.13.1r[e.13.19.1f].1N&&"3Q"!==e.13.1r[e.13.19.1f].1N||e.13.1r[e.13.19.1f].2f("1p"),e.15.8t(6U,11(){e.4R=!1,t("43").2i("14-6V"),e.1K.2i("14-2a-1A-1f"),t(e.1K).34("21","")})},7.6w=11(e){"2z"===7.13.1r[7.13.19.1f].1N&&("3w"===e&&7.13.1r[7.13.19.1f].5c(7.15.1B(),7.15.1F())||("3w"===e&&(e="6W"===7.3X?"4P":"5e"),"5e"===e&&(7.3X="6W",7.3y.1D(),7.3E.2Y(),7.2g.1s("48.1v",t.1M(7.3g,7)).1s("3T.1v",t.1M(7.3h,7)).1s("47.1v",t.1M(7.3j,7))),"4P"===e&&(7.3X="6t",7.3y.2Y(),7.3E.1D(),7.2g.4t("48.1v",t.1M(7.3g,7)).4t("3T.1v",t.1M(7.3h,7)).4t("47.1v",t.1M(7.3j,7))),7.13.1r[7.13.19.1f].5d(e,7.15.1B(),7.15.1F())))},7.2f=11(e){7.13.19.2f(e),7.13.2r(),7.13.1r[7.13.19.1f].5c(7.15.1B(),7.15.1F())&&"6t"===7.3X&&7.2g.1s("48.1v",t.1M(7.3g,7)).1s("3T.1v",t.1M(7.3h,7)).1s("47.1v",t.1M(7.3j,7)),7.13.1r[7.13.19.1f].5c(7.15.1B(),7.15.1F())||"6t"!==7.3X||7.2g.4t("48.1v",t.1M(7.3g,7)).4t("3T.1v",t.1M(7.3h,7)).4t("47.1v",t.1M(7.3j,7))},7.24()}(7.1S,7),7.71=t.2V(e.bG.bH,["bK","bP","bR"])>-1,7.3m=!1,7.4I=0,7.6T=0,7.1f=0,7.6F=!1,-1!==7.1S.4X&&(7.18.1L().1o(".14-1H").1c("1R",7.1S.4X),7.19.1L().1o(".14-1H").1c("1R",7.1S.4X),7.1p.1L().1o(".14-1H").1c("1R",7.1S.4X))},3I:11(){17 s=7;s.19.3I(),s.18.3I(),s.1p.3I(),t(i).1s("bZ.1v",t.1M(s.5p,s)).1s("c1.1v",t.1M(s.5p,s)).1s("cb.1v",t.1M(s.5p,s)),t(i).1s("cm",11(t){!0===s.1S.9f&&(37===t.5q&&(s.18.2f("3p"),s.19.2r()),39===t.5q&&(s.18.2f("2l"),s.19.2r())),27===t.5q&&s.1p.4Q()}),t(e).6S(11(){35(s.6T),s.6T=3t(11(){s.6S()},1E)})},2q:11(){7.1S=t.9l(!0,{},7.2e,7.4w),7.19.3d=7.1S.3d;17 e,i=7.18.1L();1t(!0===7.1p.4p&&7.1U.8A(7.1p.15),"1d"===7.19.1x||"1h"===7.19.1x?7.1U.2x(i):7.1U.8A(i),("2b"===7.19.1x||"1h"===7.19.1x)&&!1===7.19.3d&&7.19.1z.1b>1){17 s=1J(7.19.1z.1c("1C-2j"));e=(1J(7.1S.5D)-(7.1S.1T-1)*s)/7.1S.1T*(7.1S.4k/7.1S.5D)+7.1S.76+1J(7.1S.4k),7.18.7u=1l.3F(1E*7.1S.4k/e),e=7.1U.4v().1a()>e?e:7.1U.4v().1a()}2u e=7.1U.4v().1a()>7.1S.4k?7.1S.4k:7.1U.4v().1a();1t(7.1U.1c({1a:e}),7.18.2q(),7.19.2q(),7.1p.2q(),"1d"===7.19.1x||"2j"===7.19.1x){17 n=!1===7.19.3d?0:7.19.15.1F();7.1U.1c({1g:n+i.1F()+1J(7.19.1C)})}2u{17 o=!1===7.19.3d?0:7.19.15.1B();7.1U.1c({1a:o+i.1B()+1J(7.19.1C)}),7.1U.1c({1g:i.1F()})}},2r:11(){7.19.2r(),7.18.2r(),7.1p.2r()},6S:11(){17 i=7;i.6F||i.74!==t(e).1a()&&(i.74=t(e).1a(),i.1U.1c({1g:"0",1a:"0"}),i.2q(),t.1Y(i.1U.1o("1z"),11(t,e){i.1r[t].3e()}))},5p:11(t,e){17 i=e||7;i.1p.4R||(i.6F=!i.6F)}},t.6R.cv=11(e){7.1Y(11(){t.2P(7,"8C")||t.2P(7,"8C",1q l(t(7),e))})}}(cz,2F,2M),11(){17 t,e,i,s,n,o,r,a,h,c,l,u,p,d,m,f,g,v,y,b,w,x,S,T,C,I,M,E,z,P,D,H,L,k,Z,A,F,R,O,W,N,V,X,Y,B,q,j,G,$,U,K,4E,Q,J,61,4y,63,4u,1G=11(t,e){12 11(){12 t.4Z(e,41)}};D=11(){12"5w"===2M.bk||1i!=E.6Q},A=11(){17 t;12 t=[],"3n"!=1V 2M&&1i!==2M&&2M.6P("bp",11(){17 e,i,s,n;1j(n=[],i=0,s=t.1b;s>i;i++)e=t[i],n.1u(e(D()));12 n}),11(e){12 t.1u(e)}}(),T=11(t){17 e,i,s;i={};1j(e 2c t)s=t[e],i[e]=s;12 i},x=11(t){17 e;12 e={},11(){17 i,s,n,o;1j(i="",n=0,o=41.1b;o>n;n++)i+=41[n].4M()+",";12(s=e[i])||(e[i]=s=t.4Z(7,41)),s}},Z=11(t){12 11(e){17 i,s;12 e 3L 6O||e 3L bt||e 3L bu?11(){17 n,o,r;1j(r=[],s=n=0,o=e.1b;o>=0?o>n:n>o;s=o>=0?++n:--n)(i=6O.1y.6f.6N(41,1)).bx(0,0,e[s]),r.1u(t.4Z(7,i));12 r}.4Z(7,41):t.4Z(7,41)}},v=11(t,e){17 i,s,n;n=[];1j(i 2c e)s=e[i],n.1u(1i!=t[i]?t[i]:t[i]=s);12 n},y=11(t,e){17 i,s,n;1t(1i!=t.21)12 b(t,e);n=[];1j(i 2c e)s=e[i],n.1u(t[i]=s.1I());12 n},b=11(t,e){17 i,s,n,o,r;e=F(e),o=[],i=H(t);1j(s 2c e)r=e[s],4y.3H(s)?o.1u([s,r]):(1i!=r.1I&&(r=r.1I()),"6L"==1V r&&(r=""+r+4u(s,r)),1i!=t.6k&&t.6k(s)?t.7L(s,r):1i!=t.21&&(t.21[O(s)]=r),s 2c t&&(t[s]=r));12 o.1b>0?i?((n=1q c).58(o),t.7L("2G",n.3b().1I())):(r=o.4s(11(t){12 63(t[0],t[1])}).3W(" "),t.21[O("2G")]=r):22 0},H=11(t){17 e,i;12"3n"!=1V 6K&&1i!==6K&&"3n"!=1V 6J&&1i!==6J?t 3L 6K&&!(t 3L 6J):1i!=(e=1i!=(i=E.6Q)&&"11"==1V i.7S?i.7S(t):22 0)&&e},V=11(t,e){17 i;12 i=1l.38(10,e),1l.3F(t*i)/i},l=11(){11 t(t){17 e,i,s;1j(7.4h={},i=0,s=t.1b;s>i;i++)e=t[i],7.4h[e]=1}12 t.1y.3H=11(t){12 1===7.4h[t]},t}(),61=11(t){12 t.81(/([A-Z])/g,11(t){12"-"+t.7V()})},W=1q l("c2,c3,c4,c5,c6,c7,c8,ca,1d,1h,2j,2b,6c,6d,7W,cc,cf,cg,1a,1g,ch,ci,cj,ck,cl".3z(",")),M=1q l("2t,7Y,7Z,6I,3C,5i,6x,84".3z(",")),4y=1q l("2y,6c,6d,7W,3D,87,88,cB,2t,7Y,7Z,6I,89,6A,6B,3C,5i,6x,84,5l".3z(",")),K=1q l("cK-1g,cL,cM,9S,7N-9T,9U,cx,cy,d,9V,9W,9X,9Y,9Z,a0,a1,a2,a3,1g,a4,a5,a6,a7,a8,a9,aa-ab,ac,ad,ae,af,ag,8d-1x,8d-7a,aj,5n,al,am,an,r,ao,ap,aq,ar,as,at,au,3N-1R,3N-2w,8g-1x,8g-7a,aw,ax,ay,az,2G,8h-1x,8h-7a,aB,1a,x,aC,aD,y,aE,aF,z".3z(",")),4u=11(t,e){12"6L"!=1V e?"":W.3H(t)?"5u":M.3H(t)?"aG":""},63=11(t,e){17 i,s;12 1i!=(i=(""+e).4O(/^([0-9.-]*)([^0-9]*)$/))?(e=i[1],s=i[2]):e=1J(e),e=V(1J(e),10),(1i==s||""===s)&&(s=4u(t,e)),t+"("+e+s+")"},F=11(t){17 e,i,s,n,o,r,a,h;s={};1j(n 2c t)1t(o=t[n],4y.3H(n))1t((i=n.4O(/(2y|89|2t|3C|3D|5l)(X|Y|Z|)/))&&i[2].1b>0)s[n]=o;2u 1j(h=["X","Y","Z"],r=0,a=h.1b;a>r;r++)e=h[r],s[i[1]+e]=o;2u s[n]=o;12 s},I=11(t){17 e;12""+(e="2w"===t?1:0)+4u(t,e)},z=11(t,e){17 i,s,n,o,r,a,l,u,p,m,f;1t(o={},i=H(t),1i!=t.21)1j(r=2F.8j(t,1i),l=0,p=e.1b;p>l;l++)s=e[l],4y.3H(s)?1i==o.2G&&(n=i?1q c(1i!=(f=t.2G.aJ.aK())?f.aL:22 0):h.6H(r[O("2G")]),o.2G=n.3b()):(1i!=(a=1i!=t.6k&&t.6k(s)?t.8l(s):s 2c t?t[s]:r[s])&&"d"!==s||!K.3H(s)||(a=t.8l(s)),(""===a||1i==a)&&(a=I(s)),o[s]=C(a));2u 1j(u=0,m=e.1b;m>u;u++)o[s=e[u]]=C(t[s]);12 d(t,o),o},d=11(t,e){17 i,s;1j(s 2c e)(i=e[s])3L o&&1i!=t.21&&s 2c t.21&&(i=1q a([i,4u(s,0)])),e[s]=i;12 e},C=11(t){17 e,i,n,h;1j(n=0,h=(i=[s,r,o,a]).1b;h>n;n++)1t(1i!=(e=i[n].4j(t)))12 e;12 1i},a=11(){11 t(t){7.6u=t,7.1I=1G(7.1I,7),7.1P=1G(7.1P,7)}12 t.1y.1P=11(e,i){17 s,n,o,r,a,h;1j(r=7.6u,s=e.6u,o=[],n=a=0,h=1l.4x(r.1b,s.1b);h>=0?h>a:a>h;n=h>=0?++a:--a)o.1u(1i!=r[n].1P?r[n].1P(s[n],i):r[n]);12 1q t(o)},t.1y.1I=11(){12 7.6u.4s(11(t){12 1i!=t.1I?t.1I():t}).3W("")},t.4j=11(e){17 i,s,r,a,h,c,l,u,p,d,m;1j(e=""+e,r=[],u=0,d=(l=[{6j:/(#[a-f\\d]{3,6})/6M,6g:n,6e:11(t){12 t}},{6j:/(4l?\\([0-9.]*, ?[0-9.]*, ?[0-9.]*(?:, ?[0-9.]*)?\\))/6M,6g:n,6e:11(t){12 t}},{6j:/([-+]?[\\d.]+)/6M,6g:o,6e:1J}]).1b;d>u;u++)1j(h=(c=l[u]).6j;s=h.99(e);)r.1u({3o:s.3o,1b:s[1].1b,8u:c.6g.4j(c.6e(s[1]))});1j(a=[],i=0,p=0,m=(r=r.aY(11(t,e){12 t.3o>e.3o?1:-1})).1b;m>p;p++)(s=r[p]).3o<i||(s.3o>i&&a.1u(e.45(i,s.3o)),a.1u(s.8u),i=s.3o+s.1b);12 i<e.1b&&a.1u(e.45(i)),1q t(a)},t}(),r=11(){11 t(t){7.1I=1G(7.1I,7),7.1P=1G(7.1P,7),7.4h=t}12 t.1y.1P=11(e,i){17 s,n,o,r,a;r=7.4h,s=e.4h,o={};1j(n 2c r)a=r[n],o[n]=1i!=a.1P?a.1P(s[n],i):a;12 1q t(o)},t.1y.1I=11(){12 7.4h},t.4j=11(e){17 i,s,n;1t(e 3L 8v){s={};1j(i 2c e)n=e[i],s[i]=C(n);12 1q t(s)}12 1i},t}(),o=11(){11 t(t){7.1I=1G(7.1I,7),7.1P=1G(7.1P,7),7.6b=1J(t)}12 t.1y.1P=11(e,i){17 s;12 s=7.6b,1q t((e.6b-s)*i+s)},t.1y.1I=11(){12 V(7.6b,5)},t.4j=11(e){12"6L"==1V e?1q t(e):1i},t}(),s=11(){11 t(t){7.69=t,7.1I=1G(7.1I,7),7.1P=1G(7.1P,7)}12 t.1y.1P=11(e,i){17 s,n,o,r,a,h;1j(r=7.69,s=e.69,o=[],n=a=0,h=1l.4x(r.1b,s.1b);h>=0?h>a:a>h;n=h>=0?++a:--a)o.1u(1i!=r[n].1P?r[n].1P(s[n],i):r[n]);12 1q t(o)},t.1y.1I=11(){12 7.69.4s(11(t){12 1i!=t.1I?t.1I():t})},t.8y=11(e){12 1q t(e.4s(11(t){12 C(t)||t}).3U(11(t){12 1i!=t}))},t.4j=11(e){12 e 3L 6O?t.8y(e):1i},t}(),t=11(){11 t(t,e){7.26=1i!=t?t:{},7.1I=e,7.5X=1G(7.5X,7),7.5P=1G(7.5P,7),7.5N=1G(7.5N,7)}12 t.8D=11(e){17 i,s;12 1i!=(i=e.4O(/^#([a-f\\d]{1})([a-f\\d]{1})([a-f\\d]{1})$/i))&&(e="#"+i[1]+i[1]+i[2]+i[2]+i[3]+i[3]),1i!=(s=e.4O(/^#([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i))?1q t({r:3r(s[1],16),g:3r(s[2],16),b:3r(s[3],16),a:1},"8E"):1i},t.8F=11(e){17 i,s;12 1i!=(i=e.4O(/^4l?\\(([0-9.]*), ?([0-9.]*), ?([0-9.]*)(?:, ?([0-9.]*))?\\)$/))?1q t({r:1J(i[1]),g:1J(i[2]),b:1J(i[3]),a:1J(1i!=(s=i[4])?s:1)},1i!=i[4]?"4l":"26"):1i},t.5s=11(t){17 e;12 1===(e=t.4M(16)).1b?"0"+e:e},t.1y.5N=11(){12"#"+t.5s(7.26.r)+t.5s(7.26.g)+t.5s(7.26.b)},t.1y.5P=11(){12"26("+7.26.r+", "+7.26.g+", "+7.26.b+")"},t.1y.5X=11(){12"4l("+7.26.r+", "+7.26.g+", "+7.26.b+", "+7.26.a+")"},t}(),n=11(){11 e(t){7.1R=t,7.1I=1G(7.1I,7),7.1P=1G(7.1P,7)}12 e.1y.1P=11(i,s){17 n,o,r,a,h,c,l,u;1j(a=7.1R,n=i.1R,r={},c=0,l=(u=["r","g","b"]).1b;l>c;c++)o=u[c],h=1l.3F((n.26[o]-a.26[o])*s+a.26[o]),r[o]=1l.4x(64,1l.3O(0,h));12 o="a",h=V((n.26[o]-a.26[o])*s+a.26[o],5),r[o]=1l.4x(1,1l.3O(0,h)),1q e(1q t(r,n.1I))},e.1y.1I=11(){12"8E"===7.1R.1I?7.1R.5N():"26"===7.1R.1I?7.1R.5P():"4l"===7.1R.1I?7.1R.5X():22 0},e.4j=11(i){17 s;1t("bb"==1V i)12 s=t.8D(i)||t.8F(i),1i!=s?1q e(s):1i},e}(),i=11(){11 t(t){7.2k=t,7.6C=1G(7.6C,7),7.1I=1G(7.1I,7),7.1P=1G(7.1P,7)}12 t.1y.1P=11(e,i){17 s,n,o,r,a,h,c,l,u,p,d,m;1j(o={},r=0,l=(p=["2y","3D","2t"]).1b;l>r;r++)1j(o[n=p[r]]=[],s=a=0,d=7.2k[n].1b;d>=0?d>a:a>d;s=d>=0?++a:--a)o[n][s]=(e.2k[n][s]-7.2k[n][s])*i+7.2k[n][s];1j(s=h=1;2>=h;s=++h)o.2t[s]=e.2k.2t[s];1j(c=0,u=(m=["3C"]).1b;u>c;c++)o[n=m[c]]=(e.2k[n]-7.2k[n])*i+7.2k[n];12 1q t(o)},t.1y.1I=11(){12"2y("+7.2k.2y.3W(",")+") 2t("+7.2k.2t.3W(",")+") 5i("+7.2k.3C+") 3D("+7.2k.3D.3W(",")+")"},t.1y.6C=11(t){17 e,i,s,n,o;1j(i=(i=(i=(i=w.8K()).2y(t[0],t[1])).2t(7.2k.2t[0])).2y(-t[0],-t[1]),s=1q c(i).3b().2k.2y,o=[],e=n=0;1>=n;e=++n)o.1u(7.2k.2y[e]-=s[e]);12 o},t}(),w="3n"!=1V 2M&&1i!==2M?2M.bf("8N://8T.8Z.94/95/4e","4e"):22 0,c=11(){11 t(t){7.m=t,7.58=1G(7.58,7),7.3b=1G(7.3b,7),7.m||(7.m=w.8K())}12 t.1y.3b=11(){17 t,e,s,n,o;12 n=1q u([7.m.a,7.m.b]),o=1q u([7.m.c,7.m.d]),t=n.1b(),s=n.3G(o),n=n.42(),e=o.3Z(n,1,-s).1b(),1q i({2y:[7.m.e,7.m.f],2t:[8O*1l.6a(7.m.b,7.m.a)/1l.8Q,7.6A,7.6B],3D:[t,e],3C:s/e*8O/1l.8Q})},t.1y.58=11(t){17 e,i,s,n,o,r,a,h;1j(e={},o=0,r=t.1b;r>o;o++)e[(s=t[o])[0]]=s[1];1j(i 2c e)n=e[i],"6c"===i?7.m=7.m.2y(n,0):"6d"===i?7.m=7.m.2y(0,n):"87"===i?7.m=7.m.8R(n,1):"88"===i?7.m=7.m.8R(1,n):"6I"===i?7.m=7.m.2t(n):"5i"===i?7.m=7.m.5i(n):"6x"===i&&(7.m=7.m.6x(n));12 7.6A=1i!=(a=e.6A)?a:0,7.6B=1i!=(h=e.6B)?h:0},t}(),u=11(){11 t(t){7.1m=t,7.3Z=1G(7.3Z,7),7.42=1G(7.42,7),7.1b=1G(7.1b,7),7.66=1G(7.66,7),7.3G=1G(7.3G,7),7.e=1G(7.e,7)}12 t.1y.e=11(t){12 1>t||t>7.1m.1b?1i:7.1m[t-1]},t.1y.3G=11(t){17 e,i,s;1t(e=t.1m||t,s=0,(i=7.1m.1b)!==e.1b)12 1i;1j(i+=1;--i;)s+=7.1m[i-1]*e[i-1];12 s},t.1y.66=11(e){17 i,s;12 s=e.1m||e,3!==7.1m.1b||3!==s.1b?1i:1q t([(i=7.1m)[1]*s[2]-i[2]*s[1],i[2]*s[0]-i[0]*s[2],i[0]*s[1]-i[1]*s[0]])},t.1y.1b=11(){17 t,e,i,s,n;1j(t=0,i=0,s=(n=7.1m).1b;s>i;i++)e=n[i],t+=1l.38(e,2);12 1l.4c(t)},t.1y.42=11(){17 e,i,s,n,o;s=7.1b(),n=[],o=7.1m;1j(i 2c o)e=o[i],n[i]=e/s;12 1q t(n)},t.1y.3Z=11(e,i,s){17 n,o,r,a;1j(o=[],n=r=0,a=7.1m.1b;a>=0?a>r:r>a;n=a>=0?++r:--r)o[n]=i*7.1m[n]+s*e.1m[n];12 1q t(o)},t}(),e=11(){11 t(){7.5V=1G(7.5V,7),7.1I=1G(7.1I,7),7.1P=1G(7.1P,7)}12 t.1y.1P=11(e,i,s){17 n,o,r,a,h,c,l,u,p,d,m,f,g,v,y,b,w;1j(1i==s&&(s=1i),7,o=1q t,m=0,y=(b=["2y","3D","3C","5l"]).1b;y>m;m++)1j(o[c=b[m]]=[],r=f=0,w=7[c].1b-1;w>=0?w>=f:f>=w;r=w>=0?++f:--f)o[c][r]=1i==s||s.4T(c)>-1||s.4T(""+c+["x","y","z"][r])>-1?(e[c][r]-7[c][r])*i+7[c][r]:7[c][r];1t(1i==s||-1!==s.4T("2t")){1t(l=7.3P,u=e.3P,0>(n=l[0]*u[0]+l[1]*u[1]+l[2]*u[2]+l[3]*u[3])){1j(r=g=0;3>=g;r=++g)l[r]=-l[r];n=-n}1j(n+1>.8Y?1-n>=.8Y?(d=1l.75(n),h=1/1l.50(d),p=1l.50(d*(1-i))*h,a=1l.50(d*i)*h):(p=1-i,a=i):(u[0]=-l[1],u[1]=l[0],u[2]=-l[3],u[3]=l[2],p=1l.50(91*(.5-i)),a=1l.50(91*i)),o.3P=[],r=v=0;3>=v;r=++v)o.3P[r]=l[r]*p+u[r]*a}2u o.3P=7.3P;12 o},t.1y.1I=11(){12 7.5V().4M()},t.1y.5V=11(){17 t,e,i,s,n,o,r,a,c,l,u,p,d,m,f;1j(7,s=h.I(4),t=p=0;3>=p;t=++p)s.1m[t][3]=7.5l[t];1j(c=(n=7.3P)[0],l=n[1],u=n[2],a=n[3],o=7.3C,i=[[1,0],[2,0],[2,1]],t=d=2;d>=0;t=--d)o[t]&&(r=h.I(4),r.1m[i[t][0]][i[t][1]]=o[t],s=s.4L(r));1j(s=s.4L(1q h([[1-2*(l*l+u*u),2*(c*l-u*a),2*(c*u+l*a),0],[2*(c*l+u*a),1-2*(c*c+u*u),2*(l*u-c*a),0],[2*(c*u-l*a),2*(l*u+c*a),1-2*(c*c+l*l),0],[0,0,0,1]])),t=m=0;2>=m;t=++m){1j(e=f=0;2>=f;e=++f)s.1m[t][e]*=7.3D[t];s.1m[3][t]=7.2y[t]}12 s},t}(),h=11(){11 t(t){7.1m=t,7.4M=1G(7.4M,7),7.3b=1G(7.3b,7),7.5v=1G(7.5v,7),7.6o=1G(7.6o,7),7.6l=1G(7.6l,7),7.5Z=1G(7.5Z,7),7.4L=1G(7.4L,7),7.4B=1G(7.4B,7),7.e=1G(7.e,7)}12 t.1y.e=11(t,e){12 1>t||t>7.1m.1b||1>e||e>7.1m[0].1b?1i:7.1m[t-1][e-1]},t.1y.4B=11(){12 1q t(7.1m)},t.1y.4L=11(e){17 i,s,n,o,r,a,h,c,l,u,p,d,m;1j(d=!!e.bD,22 0===(i=e.1m||e)[0][0]&&(i=1q t(i).1m),h=u=7.1m.1b,c=i[0].1b,n=7.1m[0].1b,o=[],u+=1;--u;)1j(o[r=h-u]=[],p=c,p+=1;--p;){1j(a=c-p,m=0,l=n,l+=1;--l;)s=n-l,m+=7.1m[r][s]*i[s][a];o[r][a]=m}12 i=1q t(o),d?i.bE(1):i},t.1y.5Z=11(){17 e,i,s,n,o,r,a;1j(a=7.1m.1b,i=[],o=e=7.1m[0].1b,o+=1;--o;)1j(i[s=e-o]=[],r=a,r+=1;--r;)n=a-r,i[s][n]=7.1m[n][s];12 1q t(i)},t.1y.6l=11(){17 t,e,i,s,n,o,r,a,h,c,l,u,p,d;1j(t=7.4B(),n=a=7.1m.1b,o=7.1m[0].1b;--a;){1t(i=n-a,0===t.1m[i][i])1j(s=l=p=i+1;n>=p?n>l:l>n;s=n>=p?++l:--l)1t(0!==t.1m[s][i]){1j(e=[],h=o,h+=1;--h;)c=o-h,e.1u(t.1m[i][c]+t.1m[s][c]);t.1m[i]=e;2H}1t(0!==t.1m[i][i])1j(s=u=d=i+1;n>=d?n>u:u>n;s=n>=d?++u:--u){1j(r=t.1m[s][i]/t.1m[i][i],e=[],h=o,h+=1;--h;)c=o-h,e.1u(i>=c?0:t.1m[s][c]-t.1m[i][c]*r);t.1m[s]=e}}12 t},t.1y.6o=11(e){17 i,s,n,o,r,a,h,c,l;1t(22 0===(i=e.1m||e)[0][0]&&(i=1q t(i).1m),n=(s=7.4B()).1m[0].1b,a=c=s.1m.1b,h=i[0].1b,c!==i.1b)12 1i;1j(c+=1;--c;)1j(o=a-c,l=h,l+=1;--l;)r=h-l,s.1m[o][n+r]=i[o][r];12 s},t.1y.5v=11(){17 e,i,s,n,o,r,a,h,c,l,u,p,d;1j(a=l=7.1m.1b,h=(e=7.6o(t.I(l)).6l()).1m[0].1b,o=[],l+=1;--l;){1j(s=[],u=h,o[n=l-1]=[],i=e.1m[n][n],u+=1;--u;)p=h-u,c=e.1m[n][p]/i,s.1u(c),p>=a&&o[n].1u(c);1j(e.1m[n]=s,r=d=0;n>=0?n>d:d>n;r=n>=0?++d:--d){1j(s=[],u=h,u+=1;--u;)p=h-u,s.1u(e.1m[r][p]-e.1m[n][p]*e.1m[r][n]);e.1m[r]=s}}12 1q t(o)},t.I=11(e){17 i,s,n,o,r;1j(i=[],o=e,e+=1;--e;)1j(i[s=o-e]=[],r=o,r+=1;--r;)n=o-r,i[s][n]=s===n?1:0;12 1q t(i)},t.1y.3b=11(){17 t,i,s,n,o,r,a,h,c,l,p,d,m,f,g,v,y,b,w,x,S,T,C,I,M,E,z,P,D,H,L,k,Z,A,F;1j(7,b=[],g=[],v=[],h=[],r=[],t=[],i=E=0;3>=E;i=++E)1j(t[i]=[],s=z=0;3>=z;s=++z)t[i][s]=7.1m[i][s];1t(0===t[3][3])12!1;1j(i=P=0;3>=P;i=++P)1j(s=D=0;3>=D;s=++D)t[i][s]/=t[3][3];1j(a=7.4B(),i=H=0;2>=H;i=++H)a.1m[i][3]=0;1t(a.1m[3][3]=1,0!==t[0][3]||0!==t[1][3]||0!==t[2][3]){1j(l=1q u(t.6f(0,4)[3]),r=a.5v().5Z().4L(l).1m,i=L=0;2>=L;i=++L)t[i][3]=0;t[3][3]=1}2u r=[0,0,0,1];1j(i=k=0;2>=k;i=++k)b[i]=t[3][i],t[3][i]=0;1j(d=[],i=Z=0;2>=Z;i=++Z)d[i]=1q u(t[i].6f(0,3));1t(g[0]=d[0].1b(),d[0]=d[0].42(),v[0]=d[0].3G(d[1]),d[1]=d[1].3Z(d[0],1,-v[0]),g[1]=d[1].1b(),d[1]=d[1].42(),v[0]/=g[1],v[1]=d[0].3G(d[2]),d[2]=d[2].3Z(d[0],1,-v[1]),v[2]=d[1].3G(d[2]),d[2]=d[2].3Z(d[1],1,-v[2]),g[2]=d[2].1b(),d[2]=d[2].42(),v[1]/=g[2],v[2]/=g[2],o=d[1].66(d[2]),d[0].3G(o)<0)1j(i=A=0;2>=A;i=++A)1j(g[i]*=-1,s=F=0;2>=F;s=++F)d[i].1m[s]*=-1;m=11(t,e){12 d[t].1m[e]},(p=[])[1]=1l.bF(-m(0,2)),0!==1l.7d(p[1])?(p[0]=1l.6a(m(1,2),m(2,2)),p[2]=1l.6a(m(0,1),m(0,0))):(p[0]=1l.6a(-m(2,0),m(1,1)),p[1]=0),(y=m(0,0)+m(1,1)+m(2,2)+1)>1e-4?(T=.25/(f=.5/1l.4c(y)),C=(m(2,1)-m(1,2))*f,I=(m(0,2)-m(2,0))*f,M=(m(1,0)-m(0,1))*f):m(0,0)>m(1,1)&&m(0,0)>m(2,2)?(C=.25*(f=2*1l.4c(1+m(0,0)-m(1,1)-m(2,2))),I=(m(0,1)+m(1,0))/f,M=(m(0,2)+m(2,0))/f,T=(m(2,1)-m(1,2))/f):m(1,1)>m(2,2)?(f=2*1l.4c(1+m(1,1)-m(0,0)-m(2,2)),C=(m(0,1)+m(1,0))/f,I=.25*f,M=(m(1,2)+m(2,1))/f,T=(m(0,2)-m(2,0))/f):(f=2*1l.4c(1+m(2,2)-m(0,0)-m(1,1)),C=(m(0,2)+m(2,0))/f,I=(m(1,2)+m(2,1))/f,M=.25*f,T=(m(1,0)-m(0,1))/f),h=[C,I,M,T],(c=1q e).2y=b,c.3D=g,c.3C=v,c.3P=h,c.5l=r,c.2t=p;1j(x 2c c){w=c[x];1j(n 2c w)S=w[n],bI(S)&&(w[n]=0)}12 c},t.1y.4M=11(){17 t,e,i,s,n;1j(i="bJ(",t=s=0;3>=s;t=++s)1j(e=n=0;3>=n;e=++n)i+=V(7.1m[t][e],10),(3!==t||3!==e)&&(i+=",");12 i+")"},t.7e=x(11(t){17 e,i,s,n,o,r;12(e=2M.7G("1k")).21.1x="bL",e.21.4K="78",e.21[O("2G")]=t,2M.43.bM(e),i=1i!=(n=1i!=(o=(s=2F.8j(e,1i)).2G)?o:s[O("2G")])?n:1i!=(r=E.6Q)?r.7e(t):22 0,2M.43.bN(e),i}),t.6H=11(e){17 i,s,n,o,r,a;1j((o=1i!=e?e.4O(/bO?d?\\(([-0-9,e \\.]*)\\)/):22 0)?s=6===(i=(i=o[1].3z(",")).4s(1J)).1b?[i[0],i[1],0,0,i[2],i[3],0,0,0,0,1,0,i[4],i[5],0,1]:i:s=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],r=[],n=a=0;3>=a;n=++a)r.1u(s.6f(4*n,4*n+4));12 1q t(r)},t}(),R=x(11(t){17 e,i,s,n,o,r,a,h,c,l;1t(22 0!==2M.43.21[t])12"";1j(o="",r=0,h=(n=t.3z("-")).1b;h>r;r++)o+=(s=n[r]).45(0,1).9c()+s.45(1);1j(a=0,c=(l=["bQ","9d","bS"]).1b;c>a;a++)1t(e=(i=l[a])+o,22 0!==2M.43.21[e])12 i;12""}),O=x(11(t){17 e;12"9d"===(e=R(t))?""+e+(t.45(0,1).9c()+t.45(1)):""!==e?"-"+e.7V()+"-"+61(t):61(t)}),N="3n"!=1V 2F&&1i!==2F?2F.bT:22 0,f=[],g=[],j=!1,G=1,"3n"!=1V 2F&&1i!==2F&&2F.6P("bU",11(t){12 68===t.5q&&t.bV&&t.bW?E.9e():22 0}),1i==N&&(L=0,N=11(t){17 e,i,s;12 e=5L.5y(),s=1l.3O(0,16-(e-L)),i=2F.3t(11(){12 t(e+s)},s),L=e+s,i}),Y=!1,X=!1,U=11(){12 Y?22 0:(Y=!0,N(B))},B=11(t){17 e,i,s,n;{1t(!X){1j(i=[],s=0,n=f.1b;n>s;s++)e=f[s],m(t,e)||i.1u(e);12 0===(f=f.3U(11(t){12-1===i.4T(t)})).1b?Y=!1:N(B)}N(B)}},m=11(t,e){17 i,s,n,o,r,a,h,c;1t(1i==e.49&&(e.49=t),o=(t-e.49)/e.4w.3c,r=e.7i(o),s={},o>=1)s=e.7i.2W?e.55.4H:e.55.7l;2u{c=e.55.4H;1j(i 2c c)n=c[i],s[i]=P(n,e.55.7l[i],r)}12 y(e.3Y,s),"11"==1V(a=e.4w).6Y&&a.6Y(e.3Y,1l.4x(1,o)),o>=1&&"11"==1V(h=e.4w).3v&&h.3v(e.3Y),1>o},P=11(t,e,i){12 1i!=t&&1i!=t.1P?t.1P(e,i):1i},$=11(t,e,i,s){17 n,o,r,a,l,u,p;1t(1i!=s&&(g=g.3U(11(t){12 t.4d!==s})),E.3N(t,{5G:!1}),!i.9p)12 E.1c(t,e),22("11"==1V i.3v&&i.3v(7));l=z(t,8v.c9(e)),e=F(e),n={},u=[];1j(r 2c e)p=e[r],1i!=t.21&&4y.3H(r)?u.1u([r,p]):n[r]=C(p);12 u.1b>0&&(o=H(t),o?(a=1q c,a.58(u)):(p=u.4s(11(t){12 63(t[0],t[1])}).3W(" "),a=h.6H(h.7e(p))),n.2G=a.3b(),o&&l.2G.6C([n.2G.2k.2t[1],n.2G.2k.2t[2]])),d(t,n),f.1u({3Y:t,55:{4H:l,7l:n},4w:i,7i:i.1N.6N(i.1N,i)}),U()},J=[],Q=0,q=11(t){12 D()?N(11(){12-1!==J.4T(t)?t.5E=3t(11(){12 t.6R(),S(t.4d)},t.3J):22 0}):22 0},p=11(t,e){17 i;12 i={4d:Q+=1,49:5L.5y(),6R:t,3J:e,7r:e},q(i),J.1u(i),Q},S=11(t){12 J=J.3U(11(e){12 e.4d===t&&e.5E&&35(e.5E),e.4d!==t})},k=11(t,e){17 i;12 1i!=t?(i=t-e.49,e.7r-i):e.7r},"3n"!=1V 2F&&1i!==2F&&2F.6P("cd",11(){}),4E=1i,A(11(t){17 e,i,s,n,o,r,a,h,c,l;1t(X=!t,t){1t(Y)1j(i=5L.5y()-4E,o=0,h=f.1b;h>o;o++)1i!=(e=f[o]).49&&(e.49+=i);1j(r=0,c=J.1b;c>r;r++)(s=J[r]).3J=k(4E,s),q(s);12 4E=1i}1j(4E=5L.5y(),l=[],n=0,a=J.1b;a>n;n++)s=J[n],l.1u(35(s.5E));12 l}),(E={}).ce=11(){12 11(t){12 t}},E.7s=11(t){17 e,i,s,n,o;12 1i==t&&(t={}),v(t,E.7s.2e),s=1l.3O(1,t.5B/20),n=1l.38(20,t.33/1E),o=t.9x/4f,1l.3O(0,o),e=11(e){17 i,s;12.8,0,(.8-(i=((s=o/(1-o))-0)/(s-0)))/s*e*t.9z/1E+i},i=11(t){12 1l.38(n/10,-t)*(1-t)},11(t){17 n,r,a,h,c,l,u,p;12 l=t/(1-o)-o/(1-o),o>t?(p=o/(1-o)-o/(1-o),u=0/(1-o)-o/(1-o),c=1l.75(1/e(p)),a=(1l.75(1/e(u))-c)/(s*-o),n=e):(n=i,c=0,a=1),r=n(l),h=s*(t-o)*a+c,1-r*1l.7d(h)}},E.7x=11(t){17 e,i,s,n;12 1i==t&&(t={}),v(t,E.7x.2e),s=1l.3O(1,t.5B/20),n=1l.38(20,t.33/1E),e=11(t){12 1l.38(n/10,-t)*(1-t)},(i=11(t){17 i,n;12-1.57,1,i=e(t),n=s*t*1-1.57,i*1l.7d(n)}).2W=!0,i},E.6m=11(t){17 e,i,s,n,o,r;12 1i==t&&(t={}),v(t,E.6m.2e),i=1l.4x(t.9C/co,.8),n=t.9D/4f,1E,s=[],e=11(){17 s,n;1j(n={a:-(s=1l.4c(.cq)),b:s,H:1},t.2W&&(n.a=0,n.b=2*n.b);n.H>.9E;)e=n.b-n.a,n={a:n.b,b:n.b+e*i,H:n.H*i*i};12 n.b}(),r=11(i,s,n,o){17 r,a;12 r=(a=2/(e=s-i)*o-1-2*i/e)*a*n-n+1,t.2W&&(r=1-r),r},11(){17 o,r,a,h;1j(a={a:-(r=1l.4c(2/(1E*e*e))),b:r,H:1},t.2W&&(a.a=0,a.b=2*a.b),s.1u(a),o=e,h=[];a.b<1&&a.H>.9E;)o=a.b-a.a,a={a:a.b,b:a.b+o*i,H:a.H*n},h.1u(s.1u(a))}(),(o=11(e){17 i,n;1j(i=s[n=0];!(e>=i.a&&e<=i.b)&&(n+=1,i=s[n]););12 i?r(i.a,i.b,i.H,e):t.2W?0:1}).2W=t.2W,o},E.7z=11(t){12 1i==t&&(t={}),v(t,E.7z.2e),t.2W=!0,E.6m(t)},E.5x=11(){17 t,e,i;12 e=11(t,e,i,s,n){12 1l.38(1-t,3)*e+3*1l.38(1-t,2)*t*i+3*(1-t)*1l.38(t,2)*s+1l.38(t,3)*n},t=11(t,i,s,n,o){12{x:e(t,i.x,s.x,n.x,o.x),y:e(t,i.y,s.y,n.y,o.y)}},i=11(t,e,i){17 s,n,o,r,a,h,c,l,u;1j(s=1i,l=0,u=e.1b;u>l&&(n=e[l],t>=n(0).x&&t<=n(1).x&&(s=n),1i===s);l++);1t(!s)12 i?0:1;1j(1e-4,c=s(a=((h=1)+(r=0))/2).x,o=0;1l.cu(t-c)>1e-4&&1E>o;)t>c?r=a:h=a,c=s(a=(h+r)/2).x,o+=1;12 s(a).y},11(e){17 s,n,o;12 1i==e&&(e={}),o=e.5n,s=11(){17 e,i,n;s=[],n=11(e,i){17 n;12 n=11(s){12 t(s,e,e.cp[e.cp.1b-1],i.cp[0],i)},s.1u(n)};1j(e 2c o){1t((i=3r(e))>=o.1b-1)2H;n(o[i],o[i+1])}12 s}(),(n=11(t){12 0===t?0:1===t?1:i(t,s,7.2W)}).2W=0===o[o.1b-1].y,n}}(),E.3i=11(t){17 e,i;12 1i==t&&(t={}),e=1i!=(i=t.33)?i:E.3i.2e.33,E.5x({5n:[{x:0,y:0,cp:[{x:.92-e/4f,y:0}]},{x:1,y:1,cp:[{x:.9I+e/4f,y:1}]}]})},E.7C=11(t){17 e,i;12 1i==t&&(t={}),e=1i!=(i=t.33)?i:E.7C.2e.33,E.5x({5n:[{x:0,y:0,cp:[{x:.92-e/4f,y:0}]},{x:1,y:1,cp:[{x:1,y:1}]}]})},E.7D=11(t){17 e,i;12 1i==t&&(t={}),e=1i!=(i=t.33)?i:E.7D.2e.33,E.5x({5n:[{x:0,y:0,cp:[{x:0,y:0}]},{x:1,y:1,cp:[{x:.9I+e/4f,y:1}]}]})},E.7s.2e={5B:9L,33:7E,9x:0,9z:0},E.7x.2e={5B:9L,33:7E},E.7z.2e=E.6m.2e={9C:77,9D:7E},E.3i.2e=E.7C.2e=E.7D.2e={33:6U},E.1c=Z(11(t,e){12 b(t,e,!0)}),E.44=Z(11(t,e,i){17 s;12 1i==i&&(i={}),i=T(i),v(i,{1N:E.3i,3c:4f,3J:0,9p:!0}),i.3c=1l.3O(0,i.3c*G),i.3J=1l.3O(0,i.3J),0===i.3J?$(t,e,i):(s=E.3t(11(){12 $(t,e,i,s)},i.3J),g.1u({4d:s,3Y:t}))}),E.3N=Z(11(t,e){12 1i==e&&(e={}),1i==e.5G&&(e.5G=!0),e.5G&&(g=g.3U(11(i){12 i.3Y!==t||1i!=e.3U&&!e.3U(i)||(E.35(i.4d),!1)})),f=f.3U(11(e){12 e.3Y!==t})}),E.3t=11(t,e){12 p(t,e*G)},E.35=11(t){12 S(t)},E.9e=11(){12 G=(j=!j)?3:1,"3n"!=1V 67&&1i!==67&&"11"==1V 67.9O?67.9O("1Z.cG: cH cI "+(j?"cJ":"4S")):22 0},"9P"==("3n"==1V 5W?"3n":7c(5W))&&"9P"==7c(5W.9R)?5W.9R=E:"11"==1V 97?97("1Z",11(){12 E}):2F.1Z=E}.6N(22 0);',62,794,'|||||||this||||||||||||||||||||||||||||||||||||||||||||||||||||||||function|return|component|gc|instance||var|display|thumbs|width|length|css|top||current|height|left|null|for|div|Math|els|zoom|find|overlay|new|items|on|if|push|glasscase|class|position|prototype|li|container|outerWidth|margin|hide|100|outerHeight|nt|icon|format|parseFloat|slides|getInstance|proxy|type|lens|interpolate|addClass|color|config|nrThumbsPerRow|element|typeof|originalEvent|touches|each|dynamics||style|void|caption|init||rgb||tpEnd|tpStart|slide|right|in||defaults|navigate|slidesCnt|tmp|removeClass|bottom|props|next|ul|src|case|click|setup|changeCnt|old|rotate|else|inner|opacity|append|translate|image|dfdState|ceil|btnPrevious|btnNext|video|window|transform|break|center|border|url|newLens|document|thumb|instanceVideo|data|pageX|instanceDisplay|currentLens|pageY|newZoom|inArray|returnsToSelf|currentMousePos|show|currentSlide|instanceIFrame|currentZoom|img|friction|attr|clearTimeout|state||pow||when|decompose|duration|isOneThumbShown|fitSize|done|touchStart|touchMove|easeInOut|touchEnd|appendTo|area|isTouchMove|undefined|index|previous|mouseenter|parseInt|resolve|setTimeout|isAIZooming|complete|toggle|firstThumbSelected|btnCompress|split|abtnPrevious|abtnNext|skew|scale|btnEnlarge|round|dot|contains|initEvents|delay|mouseleave|instanceof|isThumbsOneRow|stop|max|quaternion|iframe|loader|prev|touchmove|filter|fadeIn|join|displayState|el|combine|false|arguments|normalize|body|animate|substring|isMouseEventsOn|touchend|touchstart|tStart|preload|btnDownload|sqrt|id|svg|1e3|isSlowZoom|obj|isSlowLens|create|widthDisplay|rgba|poster|instanceVC|toggleNavBtn|isEnabled|colorActiveThumb|source|map|off|st|parent|options|min|et|preventDefault|Deferred|dup|dd|currentSlideElement|_|isDownloadEnabled|background|start|mouseTimer|slowDown|visibility|multiply|toString|formats|match|nat|close|isOpened|disabled|indexOf|altTxt|floor|alt|colorIcons|slideType|apply|sin|speed|wDisplayR|hDisplayR|nbsp|properties|zType||applyProperties|isZCapEnabled|isDiffWH|speedSlowZoom|isFitScr|showNF|fit|slowLensTimer|Symbol|speedSlowLens|skewX|instancePrime|speedHideIcons|perspective|isShowAlwaysIcons|points|switch|fullScreenHandler|keyCode|gcLoading|componentToHex|mousemove|px|inverse|visible|bezier|now|mouseleaveHandler|hcenter|frequency|zPosition|heightDisplay|realTimeoutId|isHoverShowThumbs|timeout|glasscaseDA|000|vcenter|itemClass|Date|intop|toHex|inbottom|toRgb|colorLoading|downloadPosition|autoPlay|out|autoInnerZoom|toMatrix|module|toRgba|setupSlider|transpose|nth|tt|child|it|255|active|cross|console||values|atan2|value|translateX|translateY|parse|slice|klass|isFullImage|alignment|re|hasAttribute|toRightTriangular|gravity|isMouseInDspArea|augment|gcontainer|zooming|txtImgThumb|gcLoadingClass|enlarged|parts|slowZoomTimer|toggleEC|skewY|webm|pLoadingClass|rotateCX|rotateCY|applyRotateCenter|span|mp4|isFullScreenOn|calcMousePos|fromTransform|rotateZ|SVGSVGElement|SVGElement|number|gi|call|Array|addEventListener|tests|fn|resize|resizeTimer|500|noscroll|compressed|icons|change|changeThumbs|true|iOS|setupTB|setupLR|windowWidth|acos|thumbsMargin|400|hidden|trigger|thickness|setupDisplay|_typeof|cos|matrixForTransform|dfdstate|mouseenterHandler|autoPlayInterval|curve|mousePos|hasClass|end|outbottom|outtop|capZAlign|zAlign|capZPos|originalDelay|spring|capZType|wDperc|detach|font|bounce|text|forceWithGravity|removeLoader|error|easeIn|easeOut|200|addLoader|createElement|textImageNotLoaded|isZoomDiffWH|zoomWidth|slideElement|setAttribute|zoomHeight|baseline|zoomAlignment|zoomMargin|iframeWidth|showing|isSVG|ogv|ogg|toLowerCase|translateZ|iframeHeight|rotateX|rotateY|href|replace|promise|calcSettings|skewZ|enlarge|compress|scaleX|scaleY|rotateC|getInstanceDisplay|btnClose|txtImgThumbIframe|overline|IFRAME|setupZoomLens|strikethrough|underline|isMousePosInDsp|getComputedStyle|csstransforms|getAttribute|opening|padding|load|mouseEnterCB|mouseEnterDisplayCB|mouseLeaveCB|mouseLeaveDisplayCB|fadeOut|interpolable|Object|isAutoPlay|offset|createFromArray|isAutoPlayDisplay|prepend|pauseTime|gcglasscase|fromHex|hex|fromRgb|pauseTimeDisplay|isPauseOnHover|isPauseOnHoverDisplay|play|createSVGMatrix|loading|150|http|180|empty|PI|scaleNonUniform|download|www|frameborder|allowfullscreen|3e3|thumbsPosition|05|w3|about|piDouble||blank|org|2000|fill|define|symbol|exec|isOverlayEnabled|isOverlayFullImage|toUpperCase|Moz|toggleSlow|isKeypressEnabled|videoWidth|640|390|wrap|supportCanvas|extend|canvas|videoHeight|process|animated|createItem|first|default|processInput|vt|errorTxt|txtImgThumbVideo|anticipationSize|glasscaseA|anticipationStrength|VIDEO|before|bounciness|elasticity|001|zoomPosition|remove|mousemoveHandler|08|controls|isZoomEnabled|300|last|unshift|log|object|pop|exports|baseFrequency|shift|bias|diffuseConstant|divisor|dx|dy|elevation|filterRes|fx|fy|gradientTransform|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|letter|spacing|limitingConeAngle|markerHeight|markerWidth|numOctaves|order|serif|hz|pathLength|dominant|pointsAtX|pointsAtY|pointsAtZ|radius|rx|ry|seed|specularConstant|specularExponent|stdDeviation|constructor|surfaceScale|target|targetX|targetY|central|viewBox|x1|x2|y1|y2|deg|xml|base64|baseVal|consolidate|matrix|use|btoa|dc|xmlns|loading3|Fa|0x|clearInterval|setInterval|f0|eq|534|sort|isAutoScaleDisplay|isAutoScaleHeight|800|iterator|rect|ploading|fff|getContext|drawImage|Blob|toBlob|saveAs|string|instanceCnt|strict|1200|createElementNS|displayImage|600|png|anchor|visibilityState|middle|Modernizr|dblclick|NO|visibilitychange|stopPropagation|scrollTop|clientY|NodeList|HTMLCollection|scrollLeft|clientX|splice|IMAGE|test|esc|loaded|333|modulus|col|asin|navigator|platform|isNaN|matrix3d|iPad|absolute|appendChild|removeChild|matrix3|iPhone|Webkit|iPod|ms|requestAnimationFrame|keyup|shiftKey|ctrlKey|glass|onerror|fullscreenchange|weight|webkitfullscreenchange|marginTop|marginLeft|marginBottom|marginRight|paddingTop|paddingLeft|paddingBottom|keys|paddingRight|mozfullscreenchange|perspectiveX|unload|linear|perspectiveY|perspectiveZ|maxWidth|maxHeight|minWidth|minHeight|borderRadius|keydown|bold|1250||02|size|16px|urlImgPoster|abs|glassCase|displayArea|||jQuery|family|scaleZ|Arial|hiding|Helvetica|sans|js|slow|animations|enabled|accent|ascent|azimuth|slideRow'.split('|'),0,{}));



/*================ SECTIONS ================*/
theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var slideshow = (this.slideshow = '#Hero');
    var $slideshowImages = $container.find('.hero__image');
    //eslint-disable-next-line no-unused-vars
    var autoplay = (this.autoplay = $(this.slideshow).data('autoplay'));

    slickTheme.init({
      $element: $(slideshow),
      autoplay: $(slideshow).data('autoplay'),
      autoplaySpeed: $(slideshow).data('autoplayspeed'),
      arrows: true
    });

    if ($('html').hasClass('is-ios') && Shopify.designMode) {
      $(slideshow).addClass('is-ios-editor');
    }

    $slideshowImages.imagesLoaded({ background: true }).progress(function() {
      $('.hero__image').addClass('image-loaded');
    });

    theme.drawersInit();
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      $(this.slideshow).unslick();
    },

    onSelect: function() {
      if ($(this.slideshow).length) {
        var $heroContentWrapper = $(this.slideshow).find(
          '.hero__content-wrapper'
        );
        var adapt = $(this.slideshow).data('adapt');
        var $actionBar = $('.main-content').find('.hero__header');

        $heroContentWrapper.addClass('hero-initialized');
        $actionBar.toggleClass('hero__header--adapt', adapt);
      }
      theme.LeftDrawer.close();
    },

    onBlockSelect: function(evt) {
      var $slide = $('.hero__slide--' + evt.detail.blockId);
      var slideIndex = $slide.attr('index');

      $(this.slideshow).slickGoTo(slideIndex);
      if (this.autoplay) {
        $(this.slideshow).slickPause();
      }
    },

    onBlockDeselect: function() {
      if (
        this.autoplay &&
        !slickTheme.cache.$pauseButton.hasClass(slickTheme.vars.pausedClass)
      ) {
        $(this.slideshow).slickPlay();
      }
    }
  }
);

theme.SidebarMenuSection = (function() {
  function SidebarMenuSection() {
    $('.drawer-nav__toggle').on('click', function() {
      $(this)
        .parent()
        .toggleClass('drawer-nav--expanded');

      if (
        $(this)
          .parent()
          .hasClass('drawer-nav--expanded')
      ) {
        $(this)
          .children('.drawer-nav__toggle-button')
          .attr('aria-expanded', true);
        $(this)
          .find('.icon-plus')
          .removeClass('icon-plus')
          .addClass('icon-minus');
      } else {
        $(this)
          .children('.drawer-nav__toggle-button')
          .attr('aria-expanded', false);
        $(this)
          .find('.icon-minus')
          .removeClass('icon-minus')
          .addClass('icon-plus');
      }
    });
  }

  return SidebarMenuSection;
})();

theme.SidebarMenuSection.prototype = _.assignIn(
  {},
  theme.SidebarMenuSection.prototype,
  {
    onSelect: function() {
      theme.RightDrawer.close();
      theme.SearchDrawer.close();
      theme.LeftDrawer.open();
    },

    onDeselect: function() {
      theme.LeftDrawer.close();
    }
  }
);

theme.HeaderSection = (function() {
  function HeaderSection() {
    theme.drawersInit();
  }

  return HeaderSection;
})();

theme.HeaderSection.prototype = _.assignIn({}, theme.HeaderSection.prototype, {
  onSelect: function() {
    theme.LeftDrawer.close();
  }
});

theme.ActionBarSection = (function() {
  function ActionBarSection() {
    theme.ActionBar.init();
  }

  return ActionBarSection;
})();

theme.ActionBarSection.prototype = _.assignIn(
  {},
  theme.ActionBarSection.prototype,
  {
    onSelect: function() {
      theme.LeftDrawer.close();
    }
  }
);

theme.CollectionTemplate = (function() {
  function CollectionTemplate(container) {
    theme.Collection.container = container;
    theme.Collection.init();
  }

  return CollectionTemplate;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  var settings = {
    imageSize: null
  };

  var selectors = {
    addToCart: '.btn--add-to-cart',
    btnText: '.btn__text',
    cartContainer: '#CartContainer',
    originalSelectorId: 'ProductSelect',
    productForm: '.product__form--add-to-cart',
    productPrice: '.product__price--reg',
    salePrice: '.product__price .js-price',
    salePriceWrapper: '.product__price--sale',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceContainer: '[data-unit-price-container]',
    variantImage: '.product__photo--variant',
    variantImageWrapper: '.product__photo--variant-wrapper',
    SKU: '.variant-sku',
    pageLink: '[data-page-link]',
    historyState: '[data-history-state]',
    shopifyPaymentButton: '.shopify-payment-button'
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    // If section has data-history-state, Shopify.OptionSelectors will enableHistoryState
    var historyState = $container.is(selectors.historyState) ? true : false;
    var image_size = 0;

    this.$addToCartButton = $(selectors.addToCart, $container);
    this.$addToCartText = this.$addToCartButton.find(selectors.btnText);

    if (
      typeof $(selectors.variantImage, this.$container).attr('src') !==
      'undefined'
    ) {
      image_size = Shopify.Image.imageSize(
        $(selectors.variantImage, this.$container).attr('src')
      );
    }

    this.settings = $.extend({}, settings, {
      sectionId: sectionId,
      originalSelectorId: selectors.originalSelectorId + '-' + sectionId,
      historyState: historyState,
      imageSize: image_size,
      addToCartFormId: '#AddToCartForm' + '-' + sectionId,
      addToCartBtnId: '#AddToCart' + '-' + sectionId
    });

    theme.styleTextLinks();

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) return;

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.init();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    Shopify.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    );
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initVariantSelectors(this.settings.originalSelectorId);

      if (theme.settings.cartType === 'drawer') {
        ajaxCart.init({
          formSelector: this.settings.addToCartFormId,
          cartContainer: selectors.cartContainer,
          addToCartSelector: this.settings.addToCartBtnId,
          moneyFormat: theme.settings.moneyFormat
        });
      }
    },

    initVariantSelectors: function(selectorId) {
      this.optionSelector = new Shopify.OptionSelectors(selectorId, {
        product: this.productSingleObject,
        onVariantSelected: this.productVariantCallback.bind(this),
        enableHistoryState: this.settings.historyState
      });

      var firstSelector = this.optionSelector.selectors[0];

      // Add label if there is only one option and no existing label
      if (
        this.productSingleObject.options.length === 1 &&
        $(firstSelector.element).siblings('label').length === 0
      ) {
        var optionLabel = document.createElement('label');
        optionLabel.htmlFor = firstSelector.element.id;
        optionLabel.innerHTML = firstSelector.name;
        $(optionLabel).insertBefore($(firstSelector.element));
      }

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject, this.$container);

      // Uncomment this to add class so we can easily hide any
      // <select> with only one option
      // $optionSelectors.each(function () {
      //   var $el = $(this);
      //   var $select = $el.find('.single-option-selector');
      //
      //   if ($select[0].length < 2) {
      //     $el.addClass('selector-wrapper--single-option');
      //   }
      // });
    },

    simplifyVariantLabels: function(productObject, container) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (
        productObject.variants.length === 1 &&
        productObject.options.length === 1 &&
        productObject.options[0].toLowerCase().indexOf('title') >= 0 &&
        productObject.variants[0].title
          .toLowerCase()
          .indexOf('default title') >= 0
      ) {
        $('.selector-wrapper', container).hide();
      }
    },

    productVariantCallback: function(variant) {
      var $pageLink = $(selectors.pageLink, this.$container);

      if (variant) {
        if (variant.featured_image) {
          var imageId = variant.featured_image.id;
          var $newImage = $(
            selectors.variantImageWrapper + "[data-image-id='" + imageId + "']",
            this.$container
          );
          var $otherImages = $(
            selectors.variantImageWrapper +
              ":not([data-image-id='" +
              imageId +
              "'])",
            this.$container
          );

          $newImage.removeClass('hide fade-in');
          $otherImages.addClass('hide');
        } else {
          $(selectors.variantImageWrapper, this.$container).removeClass(
            'fade-in'
          );
        }

        // Select a valid variant if available
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          $(selectors.addToCart, this.$container)
            .removeClass('disabled')
            .prop('disabled', false);
          this.$addToCartText.html(theme.strings.addToCart);
          $(selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          $(selectors.addToCart, this.$container)
            .addClass('disabled')
            .prop('disabled', true);
          this.$addToCartText.html(theme.strings.soldOut);
          $(selectors.shopifyPaymentButton, this.$container).hide();
        }

        $(selectors.productPrice, this.$container).html(
          Shopify.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          ).replace(/((,00)|(\.00))$/g, '')
        );

        // Show SKU
        $(selectors.SKU, this.$container).html(variant.sku);

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(selectors.salePriceWrapper, this.$container).removeClass('hide');
          $(selectors.productPrice, this.$container).html(
            Shopify.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            ).replace(/((,00)|(\.00))$/g, '')
          );
          $(selectors.salePrice, this.$container).html(
            Shopify.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            ).replace(/((,00)|(\.00))$/g, '')
          );
          $(selectors.productPrice, this.$container).addClass('on-sale');
        } else {
          $(selectors.productPrice, this.$container).html(
            Shopify.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            ).replace(/((,00)|(\.00))$/g, '')
          );
          $(selectors.salePriceWrapper, this.$container).addClass('hide');
          $(selectors.productPrice, this.$container).removeClass('on-sale');
        }

        $(selectors.unitPriceContainer, this.$container).addClass(
          'product-price-unit--unavailable'
        );
        if (variant.unit_price_measurement) {
          $(selectors.unitPrice, this.$container).html(
            Shopify.formatMoney(variant.unit_price, theme.settings.moneyFormat)
          );
          $(selectors.unitPriceBaseUnit, this.$container).html(
            this.getBaseUnit(variant)
          );
          $(selectors.unitPriceContainer, this.$container).removeClass(
            'product-price-unit--unavailable'
          );
        }

        // Update the product page link, if it exists
        if ($pageLink.length > 0) {
          var variantUrl = this._updateUrlParameter(
            $pageLink.attr('href'),
            'variant',
            variant.id
          );
          $pageLink.attr('href', variantUrl);
        }
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(selectors.addToCart, this.$container)
          .addClass('disabled')
          .prop('disabled', true);
        this.$addToCartText.html(theme.strings.unavailable);
        $(selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });

  return Product;
})();

theme.RichTextSection = (function() {
  function RichTextSection() {}

  return RichTextSection;
})();

theme.RichTextSection.prototype = _.assignIn(
  {},
  theme.RichTextSection.prototype,
  {
    onSelect: function() {
      theme.styleTextLinks();
    }
  }
);

theme.NewsletterSection = (function() {
  function NewsletterSection() {
    theme.styleTextLinks();
  }

  return NewsletterSection;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') return;

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          var $mapContainer = $map.parents('.map-section');

          // Only show error in the theme editor
          if (Shopify.designMode) {
            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer.find('.map-section__content-wrapper').remove();
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center" style="width: 100%;">' +
                  errorMessage +
                  '</div>'
              );
          } else {
            $mapContainer.removeClass('map-section--display-map');
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (Shopify.designMode) {
    theme.$currentMapContainer.addClass('page-width map-section--load-error');
    theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
    theme.$currentMapContainer
      .find('.map-section__wrapper')
      .html(
        '<div class="errors text-center" style="width: 100%;">' +
          theme.strings.authError +
          '</div>'
      );
  } else {
    theme.$currentMapContainer.removeClass('map-section--display-map');
  }
}

theme.FeaturedVideoSection = (function() {
  function FeaturedVideoSection() {
    theme.responsiveVideos();
  }

  return FeaturedVideoSection;
})();

theme.FeaturedVideoSection.prototype = _.assignIn(
  {},
  theme.FeaturedVideoSection.prototype,
  {
    onSelect: function() {
      theme.responsiveVideos();
    }
  }
);

theme.PasswordContentSection = (function() {
  function PasswordContentSection() {
    theme.styleTextLinks();
  }

  return PasswordContentSection;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this)
    );
  }

  return ProductRecommendations;
})();


/**
 *
 *  Boundless Theme JS
 *
 *
 */
theme.init = function () {
  theme.cacheSelectors();
  theme.stringOverrides();
  theme.drawersInit();
  theme.initCart();
  theme.afterCartLoad();
  theme.rteImages();
  theme.styleTextLinks();
  theme.searchSubmit();
  theme.socialSharing();
  theme.passwordTemplate();
  theme.responsiveVideos();
  theme.checkIfIOS();
  theme.productCardImageLoadingAnimation();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
theme.cacheSelectors = function () {
  theme.cache = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $indexTemplate: $('.template-index'),
    $cartSectionTemplate: $('.cart-template-section'),

    // Drawer elements
    $drawerRight: $('.drawer--right'),
    $drawerProduct: $('.drawer--product'),
    $cartContainer: $('#CartContainer'),

    // Product grid
    $productGridItem: $('.product-item'),

    // Share buttons
    $shareButtons: $('.social-sharing'),

    // Article images
    $indentedRteImages: $('.rte--indented-images'),

    // Password Page
    $loginModal: $('#LoginModal'),

    // Announcement Bar
    $announcementBar: $('.announcement-bar'),

    // Site Header
    $siteHeaderWrapper: $('.site-header-wrapper'),
    $siteHeader: $('.site-header-container'),
    $siteHeaderCart: $('.site-header__cart'),
    $searchInput: $('.search-bar__input'),
    $searchSubmit: $('.search-bar__submit'),

    // Hero
    $heroContentWrapper: $('.hero__content-wrapper'),
    $hero: $('#Hero'),
    $heroImages: $('.hero__image'),

    // Cart classes
    cartNoCookies: 'cart--no-cookies'

  }

  theme.variables = {
    isIndexTemplate: theme.cache.$indexTemplate.length,

    // Footer
    footerTop: 0,

    // track window width to solve iOS scroll triggering resize event
    windowWidth: theme.cache.$window.width()
  };
};

theme.stringOverrides = function () {
  // Override defaults in theme.strings with potential
  // template overrides
  window.productStrings = window.productStrings || {};
  $.extend(theme.strings, window.productStrings);
};

theme.initCart = function() {
  

  if (!theme.cookiesEnabled()) {
    theme.cache.$cartContainer.addClass(theme.cache.cartNoCookies);
    theme.cache.$cartSectionTemplate.addClass(theme.cache.cartNoCookies);
  }
};

theme.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    
  });
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'onDrawerOpen': theme.searchFocus});
};

theme.searchFocus = function () {
  theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};

theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};

theme.socialSharing = function () {
  // Stop initializing if settings are disabled
  
    return;
  

  // General selectors
  var $buttons = theme.cache.$shareButtons;
  var $shareLinks = $buttons.find('a');
  var permalink = $buttons.attr('data-permalink');

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var popup = $el.attr('class').replace('-','_');
    var link = $el.attr('href');
    var w = 700;
    var h = 400;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        h = 300;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }

    window.open(link, popup, 'width=' + w + ', height=' + h);
  });
}

theme.sizeCartDrawerFooter = function () {
  // Stop if our drawer doesn't have a fixed footer
  if (!theme.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) return;


  // Elements are reprinted regularly so selectors are not cached
  var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
  var $cartInner = $('.ajaxcart__inner').removeAttr('style');
  var cartFooterHeight = $cartFooter.outerHeight();

  $cartInner.css('bottom', cartFooterHeight);
  $cartFooter.css('height', cartFooterHeight);
};

theme.afterCartLoad = function () {
  theme.cache.$cartContainer.on('ajaxCart.afterCartLoad', function(evt, cart) {
    theme.RightDrawer.open();

    // set cart bubble after ajax cart update
    if (cart.item_count > 0) {
      theme.cache.$siteHeaderCart.addClass('cart-bubble--visible');
    } else {
      theme.cache.$siteHeaderCart.removeClass('cart-bubble--visible');
    }

    // Size the cart's fixed footer
    theme.sizeCartDrawerFooter();
  });

  theme.cache.$cartContainer.on('ajaxCart.updatingQty', function() {
    $('.cart__checkout').addClass('btn--ajax-disabled');
  });
};

theme.rteImages = function () {
  if (!theme.cache.$indentedRteImages.length) return;


  var $images = theme.cache.$indentedRteImages.find('img');
  var $rteImages = imagesLoaded($images);

  $rteImages.on('always', function (instance, image) {
    $images.each(function() {
      var $el = $(this);
      var imageWidth = $el.width();
      var attr = $el.attr('style');

      // Check if undefined or float: none
      if (!attr || attr == 'float: none;') {
        // Remove grid-breaking styles if image isn't wider than parent + 20%
        // negative margins set in CSS
        if (imageWidth < theme.cache.$indentedRteImages.width() * 1.4) {
          $el.addClass('rte__no-indent');
        }
      }
    });
  });
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
}

theme.setFocus = function ($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1');

  $container.focus();

  $(document).on(eventName, function (evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();

      //only set focus once
      $(document).off(eventName)
      $container.removeAttr('tabindex');
    }
  });
};

theme.passwordTemplate = function () {
  if (!theme.cache.$loginModal.length) return;

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    $focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if (theme.cache.$loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

theme.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if(!$(this).parent().hasClass('video-wrapper')){
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

theme.checkIfIOS = function() {
  var ua = navigator.userAgent.toLowerCase();
  var isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream;

  if (isIOS) {
    $('html')
      .addClass('is-ios');
  }
};

theme.productCardImageLoadingAnimation = function() {
  var selectors = {
    image: '[data-image]',
    imageWithPlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]'
  };

  var classes = {
    loadingAnimation: 'product-item__image-container--loading',
    lazyloaded: '.lazyloaded'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .removeClass(classes.loadingAnimation)
      .find(selectors.imageWithPlaceholder)
      .hide();
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  $(selectors.image + classes.lazyloaded)
    .closest(selectors.imageWithPlaceholderWrapper)
    .removeClass(classes.loadingAnimation)
    .find(selectors.imageWithPlaceholder)
    .hide();
};

$(document).ready(function() {
  theme.init();

  var sections = new theme.Sections();

  sections.register('action-bar-section', theme.ActionBarSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('sidebar-menu-section', theme.SidebarMenuSection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('collection-template-section', theme.CollectionTemplate);
  sections.register('product', theme.Product);
  sections.register('rich-text-section', theme.RichTextSection);
  sections.register('newsletter-signup-section', theme.NewsletterSection);
  sections.register('featured-video-section', theme.FeaturedVideoSection);
  sections.register('map-section', theme.Maps);
  sections.register('password-content-section', theme.PasswordContentSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
});
